import { jsxs as B, Fragment as tt, jsx as b } from "react/jsx-runtime";
import * as Se from "react";
import st, { useMemo as me, useState as pe, useLayoutEffect as kn, forwardRef as ge, useRef as Mt, useCallback as le, useEffect as ze } from "react";
function zn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function g(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? zn(Object(n), !0).forEach(function(r) {
      ee(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : zn(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function It(e) {
  "@babel/helpers - typeof";
  return It = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, It(e);
}
function Pa(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Yn(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function Ma(e, t, n) {
  return t && Yn(e.prototype, t), n && Yn(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function ee(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function En(e, t) {
  return La(e) || Wa(e, t) || jr(e, t) || ja();
}
function ct(e) {
  return $a(e) || Ra(e) || jr(e) || Da();
}
function $a(e) {
  if (Array.isArray(e))
    return rn(e);
}
function La(e) {
  if (Array.isArray(e))
    return e;
}
function Ra(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Wa(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, o, s;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (c) {
      i = !0, s = c;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i)
          throw s;
      }
    }
    return r;
  }
}
function jr(e, t) {
  if (e) {
    if (typeof e == "string")
      return rn(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rn(e, t);
  }
}
function rn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Da() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ja() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Un = function() {
}, On = {}, Fr = {}, zr = null, Yr = {
  mark: Un,
  measure: Un
};
try {
  typeof window < "u" && (On = window), typeof document < "u" && (Fr = document), typeof MutationObserver < "u" && (zr = MutationObserver), typeof performance < "u" && (Yr = performance);
} catch {
}
var Fa = On.navigator || {}, Gn = Fa.userAgent, Hn = Gn === void 0 ? "" : Gn, Pe = On, X = Fr, Bn = zr, dt = Yr;
Pe.document;
var Ae = !!X.documentElement && !!X.head && typeof X.addEventListener == "function" && typeof X.createElement == "function", Ur = ~Hn.indexOf("MSIE") || ~Hn.indexOf("Trident/"), pt, vt, bt, yt, ht, ke = "___FONT_AWESOME___", an = 16, Gr = "fa", Hr = "svg-inline--fa", je = "data-fa-i2svg", on = "data-fa-pseudo-element", za = "data-fa-pseudo-element-pending", An = "data-prefix", In = "data-icon", qn = "fontawesome-i2svg", Ya = "async", Ua = ["HTML", "HEAD", "STYLE", "SCRIPT"], Br = function() {
  try {
    return process.env.NODE_ENV === "production";
  } catch {
    return !1;
  }
}(), V = "classic", J = "sharp", Cn = [V, J];
function lt(e) {
  return new Proxy(e, {
    get: function(n, r) {
      return r in n ? n[r] : n[V];
    }
  });
}
var nt = lt((pt = {}, ee(pt, V, {
  fa: "solid",
  fas: "solid",
  "fa-solid": "solid",
  far: "regular",
  "fa-regular": "regular",
  fal: "light",
  "fa-light": "light",
  fat: "thin",
  "fa-thin": "thin",
  fad: "duotone",
  "fa-duotone": "duotone",
  fab: "brands",
  "fa-brands": "brands",
  fak: "kit",
  fakd: "kit",
  "fa-kit": "kit",
  "fa-kit-duotone": "kit"
}), ee(pt, J, {
  fa: "solid",
  fass: "solid",
  "fa-solid": "solid",
  fasr: "regular",
  "fa-regular": "regular",
  fasl: "light",
  "fa-light": "light",
  fast: "thin",
  "fa-thin": "thin"
}), pt)), rt = lt((vt = {}, ee(vt, V, {
  solid: "fas",
  regular: "far",
  light: "fal",
  thin: "fat",
  duotone: "fad",
  brands: "fab",
  kit: "fak"
}), ee(vt, J, {
  solid: "fass",
  regular: "fasr",
  light: "fasl",
  thin: "fast"
}), vt)), at = lt((bt = {}, ee(bt, V, {
  fab: "fa-brands",
  fad: "fa-duotone",
  fak: "fa-kit",
  fal: "fa-light",
  far: "fa-regular",
  fas: "fa-solid",
  fat: "fa-thin"
}), ee(bt, J, {
  fass: "fa-solid",
  fasr: "fa-regular",
  fasl: "fa-light",
  fast: "fa-thin"
}), bt)), Ga = lt((yt = {}, ee(yt, V, {
  "fa-brands": "fab",
  "fa-duotone": "fad",
  "fa-kit": "fak",
  "fa-light": "fal",
  "fa-regular": "far",
  "fa-solid": "fas",
  "fa-thin": "fat"
}), ee(yt, J, {
  "fa-solid": "fass",
  "fa-regular": "fasr",
  "fa-light": "fasl",
  "fa-thin": "fast"
}), yt)), Ha = /fa(s|r|l|t|d|b|k|ss|sr|sl|st)?[\-\ ]/, qr = "fa-layers-text", Ba = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i, qa = lt((ht = {}, ee(ht, V, {
  900: "fas",
  400: "far",
  normal: "far",
  300: "fal",
  100: "fat"
}), ee(ht, J, {
  900: "fass",
  400: "fasr",
  300: "fasl",
  100: "fast"
}), ht)), Vr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10], Va = Vr.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]), Xa = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"], We = {
  GROUP: "duotone-group",
  SWAP_OPACITY: "swap-opacity",
  PRIMARY: "primary",
  SECONDARY: "secondary"
}, it = /* @__PURE__ */ new Set();
Object.keys(rt[V]).map(it.add.bind(it));
Object.keys(rt[J]).map(it.add.bind(it));
var Za = [].concat(Cn, ct(it), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", We.GROUP, We.SWAP_OPACITY, We.PRIMARY, We.SECONDARY]).concat(Vr.map(function(e) {
  return "".concat(e, "x");
})).concat(Va.map(function(e) {
  return "w-".concat(e);
})), Qe = Pe.FontAwesomeConfig || {};
function Ka(e) {
  var t = X.querySelector("script[" + e + "]");
  if (t)
    return t.getAttribute(e);
}
function Ja(e) {
  return e === "" ? !0 : e === "false" ? !1 : e === "true" ? !0 : e;
}
if (X && typeof X.querySelector == "function") {
  var Qa = [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]];
  Qa.forEach(function(e) {
    var t = En(e, 2), n = t[0], r = t[1], a = Ja(Ka(n));
    a != null && (Qe[r] = a);
  });
}
var Xr = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: Gr,
  replacementClass: Hr,
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
Qe.familyPrefix && (Qe.cssPrefix = Qe.familyPrefix);
var Be = g(g({}, Xr), Qe);
Be.autoReplaceSvg || (Be.observeMutations = !1);
var k = {};
Object.keys(Xr).forEach(function(e) {
  Object.defineProperty(k, e, {
    enumerable: !0,
    set: function(n) {
      Be[e] = n, et.forEach(function(r) {
        return r(k);
      });
    },
    get: function() {
      return Be[e];
    }
  });
});
Object.defineProperty(k, "familyPrefix", {
  enumerable: !0,
  set: function(t) {
    Be.cssPrefix = t, et.forEach(function(n) {
      return n(k);
    });
  },
  get: function() {
    return Be.cssPrefix;
  }
});
Pe.FontAwesomeConfig = k;
var et = [];
function ei(e) {
  return et.push(e), function() {
    et.splice(et.indexOf(e), 1);
  };
}
var Ie = an, he = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function ti(e) {
  if (!(!e || !Ae)) {
    var t = X.createElement("style");
    t.setAttribute("type", "text/css"), t.innerHTML = e;
    for (var n = X.head.childNodes, r = null, a = n.length - 1; a > -1; a--) {
      var i = n[a], o = (i.tagName || "").toUpperCase();
      ["STYLE", "LINK"].indexOf(o) > -1 && (r = i);
    }
    return X.head.insertBefore(t, r), e;
  }
}
var ni = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
function ot() {
  for (var e = 12, t = ""; e-- > 0; )
    t += ni[Math.random() * 62 | 0];
  return t;
}
function qe(e) {
  for (var t = [], n = (e || []).length >>> 0; n--; )
    t[n] = e[n];
  return t;
}
function Nn(e) {
  return e.classList ? qe(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function(t) {
    return t;
  });
}
function Zr(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function ri(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, '="').concat(Zr(e[n]), '" ');
  }, "").trim();
}
function $t(e) {
  return Object.keys(e || {}).reduce(function(t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function Tn(e) {
  return e.size !== he.size || e.x !== he.x || e.y !== he.y || e.rotate !== he.rotate || e.flipX || e.flipY;
}
function ai(e) {
  var t = e.transform, n = e.containerWidth, r = e.iconWidth, a = {
    transform: "translate(".concat(n / 2, " 256)")
  }, i = "translate(".concat(t.x * 32, ", ").concat(t.y * 32, ") "), o = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s = "rotate(".concat(t.rotate, " 0 0)"), c = {
    transform: "".concat(i, " ").concat(o, " ").concat(s)
  }, u = {
    transform: "translate(".concat(r / 2 * -1, " -256)")
  };
  return {
    outer: a,
    inner: c,
    path: u
  };
}
function ii(e) {
  var t = e.transform, n = e.width, r = n === void 0 ? an : n, a = e.height, i = a === void 0 ? an : a, o = e.startCentered, s = o === void 0 ? !1 : o, c = "";
  return s && Ur ? c += "translate(".concat(t.x / Ie - r / 2, "em, ").concat(t.y / Ie - i / 2, "em) ") : s ? c += "translate(calc(-50% + ".concat(t.x / Ie, "em), calc(-50% + ").concat(t.y / Ie, "em)) ") : c += "translate(".concat(t.x / Ie, "em, ").concat(t.y / Ie, "em) "), c += "scale(".concat(t.size / Ie * (t.flipX ? -1 : 1), ", ").concat(t.size / Ie * (t.flipY ? -1 : 1), ") "), c += "rotate(".concat(t.rotate, "deg) "), c;
}
var oi = `:root, :host {
  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";
  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";
  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";
  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";
  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";
  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";
  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";
  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";
}

svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
  overflow: visible;
  box-sizing: content-box;
}

.svg-inline--fa {
  display: var(--fa-display, inline-block);
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}
.svg-inline--fa.fa-2xs {
  vertical-align: 0.1em;
}
.svg-inline--fa.fa-xs {
  vertical-align: 0em;
}
.svg-inline--fa.fa-sm {
  vertical-align: -0.0714285705em;
}
.svg-inline--fa.fa-lg {
  vertical-align: -0.2em;
}
.svg-inline--fa.fa-xl {
  vertical-align: -0.25em;
}
.svg-inline--fa.fa-2xl {
  vertical-align: -0.3125em;
}
.svg-inline--fa.fa-pull-left {
  margin-right: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-pull-right {
  margin-left: var(--fa-pull-margin, 0.3em);
  width: auto;
}
.svg-inline--fa.fa-li {
  width: var(--fa-li-width, 2em);
  top: 0.25em;
}
.svg-inline--fa.fa-fw {
  width: var(--fa-fw-width, 1.25em);
}

.fa-layers svg.svg-inline--fa {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.fa-layers-counter, .fa-layers-text {
  display: inline-block;
  position: absolute;
  text-align: center;
}

.fa-layers {
  display: inline-block;
  height: 1em;
  position: relative;
  text-align: center;
  vertical-align: -0.125em;
  width: 1em;
}
.fa-layers svg.svg-inline--fa {
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-text {
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.fa-layers-counter {
  background-color: var(--fa-counter-background-color, #ff253a);
  border-radius: var(--fa-counter-border-radius, 1em);
  box-sizing: border-box;
  color: var(--fa-inverse, #fff);
  line-height: var(--fa-counter-line-height, 1);
  max-width: var(--fa-counter-max-width, 5em);
  min-width: var(--fa-counter-min-width, 1.5em);
  overflow: hidden;
  padding: var(--fa-counter-padding, 0.25em 0.5em);
  right: var(--fa-right, 0);
  text-overflow: ellipsis;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-counter-scale, 0.25));
          transform: scale(var(--fa-counter-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-bottom-right {
  bottom: var(--fa-bottom, 0);
  right: var(--fa-right, 0);
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom right;
          transform-origin: bottom right;
}

.fa-layers-bottom-left {
  bottom: var(--fa-bottom, 0);
  left: var(--fa-left, 0);
  right: auto;
  top: auto;
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: bottom left;
          transform-origin: bottom left;
}

.fa-layers-top-right {
  top: var(--fa-top, 0);
  right: var(--fa-right, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top right;
          transform-origin: top right;
}

.fa-layers-top-left {
  left: var(--fa-left, 0);
  right: auto;
  top: var(--fa-top, 0);
  -webkit-transform: scale(var(--fa-layers-scale, 0.25));
          transform: scale(var(--fa-layers-scale, 0.25));
  -webkit-transform-origin: top left;
          transform-origin: top left;
}

.fa-1x {
  font-size: 1em;
}

.fa-2x {
  font-size: 2em;
}

.fa-3x {
  font-size: 3em;
}

.fa-4x {
  font-size: 4em;
}

.fa-5x {
  font-size: 5em;
}

.fa-6x {
  font-size: 6em;
}

.fa-7x {
  font-size: 7em;
}

.fa-8x {
  font-size: 8em;
}

.fa-9x {
  font-size: 9em;
}

.fa-10x {
  font-size: 10em;
}

.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}

.fa-xs {
  font-size: 0.75em;
  line-height: 0.0833333337em;
  vertical-align: 0.125em;
}

.fa-sm {
  font-size: 0.875em;
  line-height: 0.0714285718em;
  vertical-align: 0.0535714295em;
}

.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}

.fa-xl {
  font-size: 1.5em;
  line-height: 0.0416666682em;
  vertical-align: -0.125em;
}

.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}

.fa-fw {
  text-align: center;
  width: 1.25em;
}

.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}

.fa-li {
  left: calc(var(--fa-li-width, 2em) * -1);
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}

.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}

.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}

.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}

.fa-beat {
  -webkit-animation-name: fa-beat;
          animation-name: fa-beat;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-bounce {
  -webkit-animation-name: fa-bounce;
          animation-name: fa-bounce;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}

.fa-fade {
  -webkit-animation-name: fa-fade;
          animation-name: fa-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-beat-fade {
  -webkit-animation-name: fa-beat-fade;
          animation-name: fa-beat-fade;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}

.fa-flip {
  -webkit-animation-name: fa-flip;
          animation-name: fa-flip;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);
          animation-timing-function: var(--fa-animation-timing, ease-in-out);
}

.fa-shake {
  -webkit-animation-name: fa-shake;
          animation-name: fa-shake;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-delay: var(--fa-animation-delay, 0s);
          animation-delay: var(--fa-animation-delay, 0s);
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 2s);
          animation-duration: var(--fa-animation-duration, 2s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, linear);
          animation-timing-function: var(--fa-animation-timing, linear);
}

.fa-spin-reverse {
  --fa-animation-direction: reverse;
}

.fa-pulse,
.fa-spin-pulse {
  -webkit-animation-name: fa-spin;
          animation-name: fa-spin;
  -webkit-animation-direction: var(--fa-animation-direction, normal);
          animation-direction: var(--fa-animation-direction, normal);
  -webkit-animation-duration: var(--fa-animation-duration, 1s);
          animation-duration: var(--fa-animation-duration, 1s);
  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);
          animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));
          animation-timing-function: var(--fa-animation-timing, steps(8));
}

@media (prefers-reduced-motion: reduce) {
  .fa-beat,
.fa-bounce,
.fa-fade,
.fa-beat-fade,
.fa-flip,
.fa-pulse,
.fa-shake,
.fa-spin,
.fa-spin-pulse {
    -webkit-animation-delay: -1ms;
            animation-delay: -1ms;
    -webkit-animation-duration: 1ms;
            animation-duration: 1ms;
    -webkit-animation-iteration-count: 1;
            animation-iteration-count: 1;
    -webkit-transition-delay: 0s;
            transition-delay: 0s;
    -webkit-transition-duration: 0s;
            transition-duration: 0s;
  }
}
@-webkit-keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-beat {
  0%, 90% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  45% {
    -webkit-transform: scale(var(--fa-beat-scale, 1.25));
            transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@-webkit-keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-bounce {
  0% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  10% {
    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
  100% {
    -webkit-transform: scale(1, 1) translateY(0);
            transform: scale(1, 1) translateY(0);
  }
}
@-webkit-keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@-webkit-keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-beat-fade {
  0%, 100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    -webkit-transform: scale(1);
            transform: scale(1);
  }
  50% {
    opacity: 1;
    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));
            transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@-webkit-keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-flip {
  50% {
    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@-webkit-keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@keyframes fa-shake {
  0% {
    -webkit-transform: rotate(-15deg);
            transform: rotate(-15deg);
  }
  4% {
    -webkit-transform: rotate(15deg);
            transform: rotate(15deg);
  }
  8%, 24% {
    -webkit-transform: rotate(-18deg);
            transform: rotate(-18deg);
  }
  12%, 28% {
    -webkit-transform: rotate(18deg);
            transform: rotate(18deg);
  }
  16% {
    -webkit-transform: rotate(-22deg);
            transform: rotate(-22deg);
  }
  20% {
    -webkit-transform: rotate(22deg);
            transform: rotate(22deg);
  }
  32% {
    -webkit-transform: rotate(-12deg);
            transform: rotate(-12deg);
  }
  36% {
    -webkit-transform: rotate(12deg);
            transform: rotate(12deg);
  }
  40%, 100% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
}
@-webkit-keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes fa-spin {
  0% {
    -webkit-transform: rotate(0deg);
            transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
}

.fa-rotate-180 {
  -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
}

.fa-rotate-270 {
  -webkit-transform: rotate(270deg);
          transform: rotate(270deg);
}

.fa-flip-horizontal {
  -webkit-transform: scale(-1, 1);
          transform: scale(-1, 1);
}

.fa-flip-vertical {
  -webkit-transform: scale(1, -1);
          transform: scale(1, -1);
}

.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  -webkit-transform: scale(-1, -1);
          transform: scale(-1, -1);
}

.fa-rotate-by {
  -webkit-transform: rotate(var(--fa-rotate-angle, 0));
          transform: rotate(var(--fa-rotate-angle, 0));
}

.fa-stack {
  display: inline-block;
  vertical-align: middle;
  height: 2em;
  position: relative;
  width: 2.5em;
}

.fa-stack-1x,
.fa-stack-2x {
  bottom: 0;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 0;
  z-index: var(--fa-stack-z-index, auto);
}

.svg-inline--fa.fa-stack-1x {
  height: 1em;
  width: 1.25em;
}
.svg-inline--fa.fa-stack-2x {
  height: 2em;
  width: 2.5em;
}

.fa-inverse {
  color: var(--fa-inverse, #fff);
}

.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.svg-inline--fa .fa-primary {
  fill: var(--fa-primary-color, currentColor);
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa .fa-secondary {
  fill: var(--fa-secondary-color, currentColor);
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-primary {
  opacity: var(--fa-secondary-opacity, 0.4);
}

.svg-inline--fa.fa-swap-opacity .fa-secondary {
  opacity: var(--fa-primary-opacity, 1);
}

.svg-inline--fa mask .fa-primary,
.svg-inline--fa mask .fa-secondary {
  fill: black;
}

.fad.fa-inverse,
.fa-duotone.fa-inverse {
  color: var(--fa-inverse, #fff);
}`;
function Kr() {
  var e = Gr, t = Hr, n = k.cssPrefix, r = k.replacementClass, a = oi;
  if (n !== e || r !== t) {
    var i = new RegExp("\\.".concat(e, "\\-"), "g"), o = new RegExp("\\--".concat(e, "\\-"), "g"), s = new RegExp("\\.".concat(t), "g");
    a = a.replace(i, ".".concat(n, "-")).replace(o, "--".concat(n, "-")).replace(s, ".".concat(r));
  }
  return a;
}
var Vn = !1;
function Dt() {
  k.autoAddCss && !Vn && (ti(Kr()), Vn = !0);
}
var si = {
  mixout: function() {
    return {
      dom: {
        css: Kr,
        insertCss: Dt
      }
    };
  },
  hooks: function() {
    return {
      beforeDOMElementCreation: function() {
        Dt();
      },
      beforeI2svg: function() {
        Dt();
      }
    };
  }
}, Ee = Pe || {};
Ee[ke] || (Ee[ke] = {});
Ee[ke].styles || (Ee[ke].styles = {});
Ee[ke].hooks || (Ee[ke].hooks = {});
Ee[ke].shims || (Ee[ke].shims = []);
var de = Ee[ke], Jr = [], ci = function e() {
  X.removeEventListener("DOMContentLoaded", e), Ct = 1, Jr.map(function(t) {
    return t();
  });
}, Ct = !1;
Ae && (Ct = (X.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(X.readyState), Ct || X.addEventListener("DOMContentLoaded", ci));
function li(e) {
  Ae && (Ct ? setTimeout(e, 0) : Jr.push(e));
}
function ft(e) {
  var t = e.tag, n = e.attributes, r = n === void 0 ? {} : n, a = e.children, i = a === void 0 ? [] : a;
  return typeof e == "string" ? Zr(e) : "<".concat(t, " ").concat(ri(r), ">").concat(i.map(ft).join(""), "</").concat(t, ">");
}
function Xn(e, t, n) {
  if (e && e[t] && e[t][n])
    return {
      prefix: t,
      iconName: n,
      icon: e[t][n]
    };
}
var fi = function(t, n) {
  return function(r, a, i, o) {
    return t.call(n, r, a, i, o);
  };
}, jt = function(t, n, r, a) {
  var i = Object.keys(t), o = i.length, s = a !== void 0 ? fi(n, a) : n, c, u, l;
  for (r === void 0 ? (c = 1, l = t[i[0]]) : (c = 0, l = r); c < o; c++)
    u = i[c], l = s(l, t[u], u, t);
  return l;
};
function ui(e) {
  for (var t = [], n = 0, r = e.length; n < r; ) {
    var a = e.charCodeAt(n++);
    if (a >= 55296 && a <= 56319 && n < r) {
      var i = e.charCodeAt(n++);
      (i & 64512) == 56320 ? t.push(((a & 1023) << 10) + (i & 1023) + 65536) : (t.push(a), n--);
    } else
      t.push(a);
  }
  return t;
}
function sn(e) {
  var t = ui(e);
  return t.length === 1 ? t[0].toString(16) : null;
}
function mi(e, t) {
  var n = e.length, r = e.charCodeAt(t), a;
  return r >= 55296 && r <= 56319 && n > t + 1 && (a = e.charCodeAt(t + 1), a >= 56320 && a <= 57343) ? (r - 55296) * 1024 + a - 56320 + 65536 : r;
}
function Zn(e) {
  return Object.keys(e).reduce(function(t, n) {
    var r = e[n], a = !!r.icon;
    return a ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function cn(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = n.skipHooks, a = r === void 0 ? !1 : r, i = Zn(t);
  typeof de.hooks.addPack == "function" && !a ? de.hooks.addPack(e, Zn(t)) : de.styles[e] = g(g({}, de.styles[e] || {}), i), e === "fas" && cn("fa", t);
}
var gt, _t, wt, Ye = de.styles, di = de.shims, pi = (gt = {}, ee(gt, V, Object.values(at[V])), ee(gt, J, Object.values(at[J])), gt), Pn = null, Qr = {}, ea = {}, ta = {}, na = {}, ra = {}, vi = (_t = {}, ee(_t, V, Object.keys(nt[V])), ee(_t, J, Object.keys(nt[J])), _t);
function bi(e) {
  return ~Za.indexOf(e);
}
function yi(e, t) {
  var n = t.split("-"), r = n[0], a = n.slice(1).join("-");
  return r === e && a !== "" && !bi(a) ? a : null;
}
var aa = function() {
  var t = function(i) {
    return jt(Ye, function(o, s, c) {
      return o[c] = jt(s, i, {}), o;
    }, {});
  };
  Qr = t(function(a, i, o) {
    if (i[3] && (a[i[3]] = o), i[2]) {
      var s = i[2].filter(function(c) {
        return typeof c == "number";
      });
      s.forEach(function(c) {
        a[c.toString(16)] = o;
      });
    }
    return a;
  }), ea = t(function(a, i, o) {
    if (a[o] = o, i[2]) {
      var s = i[2].filter(function(c) {
        return typeof c == "string";
      });
      s.forEach(function(c) {
        a[c] = o;
      });
    }
    return a;
  }), ra = t(function(a, i, o) {
    var s = i[2];
    return a[o] = o, s.forEach(function(c) {
      a[c] = o;
    }), a;
  });
  var n = "far" in Ye || k.autoFetchSvg, r = jt(di, function(a, i) {
    var o = i[0], s = i[1], c = i[2];
    return s === "far" && !n && (s = "fas"), typeof o == "string" && (a.names[o] = {
      prefix: s,
      iconName: c
    }), typeof o == "number" && (a.unicodes[o.toString(16)] = {
      prefix: s,
      iconName: c
    }), a;
  }, {
    names: {},
    unicodes: {}
  });
  ta = r.names, na = r.unicodes, Pn = Lt(k.styleDefault, {
    family: k.familyDefault
  });
};
ei(function(e) {
  Pn = Lt(e.styleDefault, {
    family: k.familyDefault
  });
});
aa();
function Mn(e, t) {
  return (Qr[e] || {})[t];
}
function hi(e, t) {
  return (ea[e] || {})[t];
}
function De(e, t) {
  return (ra[e] || {})[t];
}
function ia(e) {
  return ta[e] || {
    prefix: null,
    iconName: null
  };
}
function gi(e) {
  var t = na[e], n = Mn("fas", e);
  return t || (n ? {
    prefix: "fas",
    iconName: n
  } : null) || {
    prefix: null,
    iconName: null
  };
}
function Me() {
  return Pn;
}
var $n = function() {
  return {
    prefix: null,
    iconName: null,
    rest: []
  };
};
function Lt(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.family, r = n === void 0 ? V : n, a = nt[r][e], i = rt[r][e] || rt[r][a], o = e in de.styles ? e : null;
  return i || o || null;
}
var Kn = (wt = {}, ee(wt, V, Object.keys(at[V])), ee(wt, J, Object.keys(at[J])), wt);
function Rt(e) {
  var t, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.skipLookups, a = r === void 0 ? !1 : r, i = (t = {}, ee(t, V, "".concat(k.cssPrefix, "-").concat(V)), ee(t, J, "".concat(k.cssPrefix, "-").concat(J)), t), o = null, s = V;
  (e.includes(i[V]) || e.some(function(u) {
    return Kn[V].includes(u);
  })) && (s = V), (e.includes(i[J]) || e.some(function(u) {
    return Kn[J].includes(u);
  })) && (s = J);
  var c = e.reduce(function(u, l) {
    var m = yi(k.cssPrefix, l);
    if (Ye[l] ? (l = pi[s].includes(l) ? Ga[s][l] : l, o = l, u.prefix = l) : vi[s].indexOf(l) > -1 ? (o = l, u.prefix = Lt(l, {
      family: s
    })) : m ? u.iconName = m : l !== k.replacementClass && l !== i[V] && l !== i[J] && u.rest.push(l), !a && u.prefix && u.iconName) {
      var p = o === "fa" ? ia(u.iconName) : {}, y = De(u.prefix, u.iconName);
      p.prefix && (o = null), u.iconName = p.iconName || y || u.iconName, u.prefix = p.prefix || u.prefix, u.prefix === "far" && !Ye.far && Ye.fas && !k.autoFetchSvg && (u.prefix = "fas");
    }
    return u;
  }, $n());
  return (e.includes("fa-brands") || e.includes("fab")) && (c.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (c.prefix = "fad"), !c.prefix && s === J && (Ye.fass || k.autoFetchSvg) && (c.prefix = "fass", c.iconName = De(c.prefix, c.iconName) || c.iconName), (c.prefix === "fa" || o === "fa") && (c.prefix = Me() || "fas"), c;
}
var _i = /* @__PURE__ */ function() {
  function e() {
    Pa(this, e), this.definitions = {};
  }
  return Ma(e, [{
    key: "add",
    value: function() {
      for (var n = this, r = arguments.length, a = new Array(r), i = 0; i < r; i++)
        a[i] = arguments[i];
      var o = a.reduce(this._pullDefinitions, {});
      Object.keys(o).forEach(function(s) {
        n.definitions[s] = g(g({}, n.definitions[s] || {}), o[s]), cn(s, o[s]);
        var c = at[V][s];
        c && cn(c, o[s]), aa();
      });
    }
  }, {
    key: "reset",
    value: function() {
      this.definitions = {};
    }
  }, {
    key: "_pullDefinitions",
    value: function(n, r) {
      var a = r.prefix && r.iconName && r.icon ? {
        0: r
      } : r;
      return Object.keys(a).map(function(i) {
        var o = a[i], s = o.prefix, c = o.iconName, u = o.icon, l = u[2];
        n[s] || (n[s] = {}), l.length > 0 && l.forEach(function(m) {
          typeof m == "string" && (n[s][m] = u);
        }), n[s][c] = u;
      }), n;
    }
  }]), e;
}(), Jn = [], Ue = {}, He = {}, wi = Object.keys(He);
function xi(e, t) {
  var n = t.mixoutsTo;
  return Jn = e, Ue = {}, Object.keys(He).forEach(function(r) {
    wi.indexOf(r) === -1 && delete He[r];
  }), Jn.forEach(function(r) {
    var a = r.mixout ? r.mixout() : {};
    if (Object.keys(a).forEach(function(o) {
      typeof a[o] == "function" && (n[o] = a[o]), It(a[o]) === "object" && Object.keys(a[o]).forEach(function(s) {
        n[o] || (n[o] = {}), n[o][s] = a[o][s];
      });
    }), r.hooks) {
      var i = r.hooks();
      Object.keys(i).forEach(function(o) {
        Ue[o] || (Ue[o] = []), Ue[o].push(i[o]);
      });
    }
    r.provides && r.provides(He);
  }), n;
}
function ln(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), a = 2; a < n; a++)
    r[a - 2] = arguments[a];
  var i = Ue[e] || [];
  return i.forEach(function(o) {
    t = o.apply(null, [t].concat(r));
  }), t;
}
function Fe(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  var a = Ue[e] || [];
  a.forEach(function(i) {
    i.apply(null, n);
  });
}
function Oe() {
  var e = arguments[0], t = Array.prototype.slice.call(arguments, 1);
  return He[e] ? He[e].apply(null, t) : void 0;
}
function fn(e) {
  e.prefix === "fa" && (e.prefix = "fas");
  var t = e.iconName, n = e.prefix || Me();
  if (t)
    return t = De(n, t) || t, Xn(oa.definitions, n, t) || Xn(de.styles, n, t);
}
var oa = new _i(), Si = function() {
  k.autoReplaceSvg = !1, k.observeMutations = !1, Fe("noAuto");
}, ki = {
  i2svg: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Ae ? (Fe("beforeI2svg", t), Oe("pseudoElements2svg", t), Oe("i2svg", t)) : Promise.reject("Operation requires a DOM of some kind.");
  },
  watch: function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot;
    k.autoReplaceSvg === !1 && (k.autoReplaceSvg = !0), k.observeMutations = !0, li(function() {
      Oi({
        autoReplaceSvgRoot: n
      }), Fe("watch", t);
    });
  }
}, Ei = {
  icon: function(t) {
    if (t === null)
      return null;
    if (It(t) === "object" && t.prefix && t.iconName)
      return {
        prefix: t.prefix,
        iconName: De(t.prefix, t.iconName) || t.iconName
      };
    if (Array.isArray(t) && t.length === 2) {
      var n = t[1].indexOf("fa-") === 0 ? t[1].slice(3) : t[1], r = Lt(t[0]);
      return {
        prefix: r,
        iconName: De(r, n) || n
      };
    }
    if (typeof t == "string" && (t.indexOf("".concat(k.cssPrefix, "-")) > -1 || t.match(Ha))) {
      var a = Rt(t.split(" "), {
        skipLookups: !0
      });
      return {
        prefix: a.prefix || Me(),
        iconName: De(a.prefix, a.iconName) || a.iconName
      };
    }
    if (typeof t == "string") {
      var i = Me();
      return {
        prefix: i,
        iconName: De(i, t) || t
      };
    }
  }
}, fe = {
  noAuto: Si,
  config: k,
  dom: ki,
  parse: Ei,
  library: oa,
  findIconDefinition: fn,
  toHtml: ft
}, Oi = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.autoReplaceSvgRoot, r = n === void 0 ? X : n;
  (Object.keys(de.styles).length > 0 || k.autoFetchSvg) && Ae && k.autoReplaceSvg && fe.dom.i2svg({
    node: r
  });
};
function Wt(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function() {
      return e.abstract.map(function(r) {
        return ft(r);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function() {
      if (Ae) {
        var r = X.createElement("div");
        return r.innerHTML = e.html, r.children;
      }
    }
  }), e;
}
function Ai(e) {
  var t = e.children, n = e.main, r = e.mask, a = e.attributes, i = e.styles, o = e.transform;
  if (Tn(o) && n.found && !r.found) {
    var s = n.width, c = n.height, u = {
      x: s / c / 2,
      y: 0.5
    };
    a.style = $t(g(g({}, i), {}, {
      "transform-origin": "".concat(u.x + o.x / 16, "em ").concat(u.y + o.y / 16, "em")
    }));
  }
  return [{
    tag: "svg",
    attributes: a,
    children: t
  }];
}
function Ii(e) {
  var t = e.prefix, n = e.iconName, r = e.children, a = e.attributes, i = e.symbol, o = i === !0 ? "".concat(t, "-").concat(k.cssPrefix, "-").concat(n) : i;
  return [{
    tag: "svg",
    attributes: {
      style: "display: none;"
    },
    children: [{
      tag: "symbol",
      attributes: g(g({}, a), {}, {
        id: o
      }),
      children: r
    }]
  }];
}
function Ln(e) {
  var t = e.icons, n = t.main, r = t.mask, a = e.prefix, i = e.iconName, o = e.transform, s = e.symbol, c = e.title, u = e.maskId, l = e.titleId, m = e.extra, p = e.watchable, y = p === void 0 ? !1 : p, x = r.found ? r : n, _ = x.width, O = x.height, I = a === "fak", A = [k.replacementClass, i ? "".concat(k.cssPrefix, "-").concat(i) : ""].filter(function(Q) {
    return m.classes.indexOf(Q) === -1;
  }).filter(function(Q) {
    return Q !== "" || !!Q;
  }).concat(m.classes).join(" "), h = {
    children: [],
    attributes: g(g({}, m.attributes), {}, {
      "data-prefix": a,
      "data-icon": i,
      class: A,
      role: m.attributes.role || "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 ".concat(_, " ").concat(O)
    })
  }, S = I && !~m.classes.indexOf("fa-fw") ? {
    width: "".concat(_ / O * 16 * 0.0625, "em")
  } : {};
  y && (h.attributes[je] = ""), c && (h.children.push({
    tag: "title",
    attributes: {
      id: h.attributes["aria-labelledby"] || "title-".concat(l || ot())
    },
    children: [c]
  }), delete h.attributes.title);
  var f = g(g({}, h), {}, {
    prefix: a,
    iconName: i,
    main: n,
    mask: r,
    maskId: u,
    transform: o,
    symbol: s,
    styles: g(g({}, S), m.styles)
  }), $ = r.found && n.found ? Oe("generateAbstractMask", f) || {
    children: [],
    attributes: {}
  } : Oe("generateAbstractIcon", f) || {
    children: [],
    attributes: {}
  }, q = $.children, re = $.attributes;
  return f.children = q, f.attributes = re, s ? Ii(f) : Ai(f);
}
function Qn(e) {
  var t = e.content, n = e.width, r = e.height, a = e.transform, i = e.title, o = e.extra, s = e.watchable, c = s === void 0 ? !1 : s, u = g(g(g({}, o.attributes), i ? {
    title: i
  } : {}), {}, {
    class: o.classes.join(" ")
  });
  c && (u[je] = "");
  var l = g({}, o.styles);
  Tn(a) && (l.transform = ii({
    transform: a,
    startCentered: !0,
    width: n,
    height: r
  }), l["-webkit-transform"] = l.transform);
  var m = $t(l);
  m.length > 0 && (u.style = m);
  var p = [];
  return p.push({
    tag: "span",
    attributes: u,
    children: [t]
  }), i && p.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), p;
}
function Ci(e) {
  var t = e.content, n = e.title, r = e.extra, a = g(g(g({}, r.attributes), n ? {
    title: n
  } : {}), {}, {
    class: r.classes.join(" ")
  }), i = $t(r.styles);
  i.length > 0 && (a.style = i);
  var o = [];
  return o.push({
    tag: "span",
    attributes: a,
    children: [t]
  }), n && o.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), o;
}
var Ft = de.styles;
function un(e) {
  var t = e[0], n = e[1], r = e.slice(4), a = En(r, 1), i = a[0], o = null;
  return Array.isArray(i) ? o = {
    tag: "g",
    attributes: {
      class: "".concat(k.cssPrefix, "-").concat(We.GROUP)
    },
    children: [{
      tag: "path",
      attributes: {
        class: "".concat(k.cssPrefix, "-").concat(We.SECONDARY),
        fill: "currentColor",
        d: i[0]
      }
    }, {
      tag: "path",
      attributes: {
        class: "".concat(k.cssPrefix, "-").concat(We.PRIMARY),
        fill: "currentColor",
        d: i[1]
      }
    }]
  } : o = {
    tag: "path",
    attributes: {
      fill: "currentColor",
      d: i
    }
  }, {
    found: !0,
    width: t,
    height: n,
    icon: o
  };
}
var Ni = {
  found: !1,
  width: 512,
  height: 512
};
function Ti(e, t) {
  !Br && !k.showMissingIcons && e && console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
}
function mn(e, t) {
  var n = t;
  return t === "fa" && k.styleDefault !== null && (t = Me()), new Promise(function(r, a) {
    if (Oe("missingIconAbstract"), n === "fa") {
      var i = ia(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && Ft[t] && Ft[t][e]) {
      var o = Ft[t][e];
      return r(un(o));
    }
    Ti(e, t), r(g(g({}, Ni), {}, {
      icon: k.showMissingIcons && e ? Oe("missingIconAbstract") || {} : {}
    }));
  });
}
var er = function() {
}, dn = k.measurePerformance && dt && dt.mark && dt.measure ? dt : {
  mark: er,
  measure: er
}, Ke = 'FA "6.5.2"', Pi = function(t) {
  return dn.mark("".concat(Ke, " ").concat(t, " begins")), function() {
    return sa(t);
  };
}, sa = function(t) {
  dn.mark("".concat(Ke, " ").concat(t, " ends")), dn.measure("".concat(Ke, " ").concat(t), "".concat(Ke, " ").concat(t, " begins"), "".concat(Ke, " ").concat(t, " ends"));
}, Rn = {
  begin: Pi,
  end: sa
}, Et = function() {
};
function tr(e) {
  var t = e.getAttribute ? e.getAttribute(je) : null;
  return typeof t == "string";
}
function Mi(e) {
  var t = e.getAttribute ? e.getAttribute(An) : null, n = e.getAttribute ? e.getAttribute(In) : null;
  return t && n;
}
function $i(e) {
  return e && e.classList && e.classList.contains && e.classList.contains(k.replacementClass);
}
function Li() {
  if (k.autoReplaceSvg === !0)
    return Ot.replace;
  var e = Ot[k.autoReplaceSvg];
  return e || Ot.replace;
}
function Ri(e) {
  return X.createElementNS("http://www.w3.org/2000/svg", e);
}
function Wi(e) {
  return X.createElement(e);
}
function ca(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.ceFn, r = n === void 0 ? e.tag === "svg" ? Ri : Wi : n;
  if (typeof e == "string")
    return X.createTextNode(e);
  var a = r(e.tag);
  Object.keys(e.attributes || []).forEach(function(o) {
    a.setAttribute(o, e.attributes[o]);
  });
  var i = e.children || [];
  return i.forEach(function(o) {
    a.appendChild(ca(o, {
      ceFn: r
    }));
  }), a;
}
function Di(e) {
  var t = " ".concat(e.outerHTML, " ");
  return t = "".concat(t, "Font Awesome fontawesome.com "), t;
}
var Ot = {
  replace: function(t) {
    var n = t[0];
    if (n.parentNode)
      if (t[1].forEach(function(a) {
        n.parentNode.insertBefore(ca(a), n);
      }), n.getAttribute(je) === null && k.keepOriginalSource) {
        var r = X.createComment(Di(n));
        n.parentNode.replaceChild(r, n);
      } else
        n.remove();
  },
  nest: function(t) {
    var n = t[0], r = t[1];
    if (~Nn(n).indexOf(k.replacementClass))
      return Ot.replace(t);
    var a = new RegExp("".concat(k.cssPrefix, "-.*"));
    if (delete r[0].attributes.id, r[0].attributes.class) {
      var i = r[0].attributes.class.split(" ").reduce(function(s, c) {
        return c === k.replacementClass || c.match(a) ? s.toSvg.push(c) : s.toNode.push(c), s;
      }, {
        toNode: [],
        toSvg: []
      });
      r[0].attributes.class = i.toSvg.join(" "), i.toNode.length === 0 ? n.removeAttribute("class") : n.setAttribute("class", i.toNode.join(" "));
    }
    var o = r.map(function(s) {
      return ft(s);
    }).join(`
`);
    n.setAttribute(je, ""), n.innerHTML = o;
  }
};
function nr(e) {
  e();
}
function la(e, t) {
  var n = typeof t == "function" ? t : Et;
  if (e.length === 0)
    n();
  else {
    var r = nr;
    k.mutateApproach === Ya && (r = Pe.requestAnimationFrame || nr), r(function() {
      var a = Li(), i = Rn.begin("mutate");
      e.map(a), i(), n();
    });
  }
}
var Wn = !1;
function fa() {
  Wn = !0;
}
function pn() {
  Wn = !1;
}
var Nt = null;
function rr(e) {
  if (Bn && k.observeMutations) {
    var t = e.treeCallback, n = t === void 0 ? Et : t, r = e.nodeCallback, a = r === void 0 ? Et : r, i = e.pseudoElementsCallback, o = i === void 0 ? Et : i, s = e.observeMutationsRoot, c = s === void 0 ? X : s;
    Nt = new Bn(function(u) {
      if (!Wn) {
        var l = Me();
        qe(u).forEach(function(m) {
          if (m.type === "childList" && m.addedNodes.length > 0 && !tr(m.addedNodes[0]) && (k.searchPseudoElements && o(m.target), n(m.target)), m.type === "attributes" && m.target.parentNode && k.searchPseudoElements && o(m.target.parentNode), m.type === "attributes" && tr(m.target) && ~Xa.indexOf(m.attributeName))
            if (m.attributeName === "class" && Mi(m.target)) {
              var p = Rt(Nn(m.target)), y = p.prefix, x = p.iconName;
              m.target.setAttribute(An, y || l), x && m.target.setAttribute(In, x);
            } else
              $i(m.target) && a(m.target);
        });
      }
    }), Ae && Nt.observe(c, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function ji() {
  Nt && Nt.disconnect();
}
function Fi(e) {
  var t = e.getAttribute("style"), n = [];
  return t && (n = t.split(";").reduce(function(r, a) {
    var i = a.split(":"), o = i[0], s = i.slice(1);
    return o && s.length > 0 && (r[o] = s.join(":").trim()), r;
  }, {})), n;
}
function zi(e) {
  var t = e.getAttribute("data-prefix"), n = e.getAttribute("data-icon"), r = e.innerText !== void 0 ? e.innerText.trim() : "", a = Rt(Nn(e));
  return a.prefix || (a.prefix = Me()), t && n && (a.prefix = t, a.iconName = n), a.iconName && a.prefix || (a.prefix && r.length > 0 && (a.iconName = hi(a.prefix, e.innerText) || Mn(a.prefix, sn(e.innerText))), !a.iconName && k.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (a.iconName = e.firstChild.data)), a;
}
function Yi(e) {
  var t = qe(e.attributes).reduce(function(a, i) {
    return a.name !== "class" && a.name !== "style" && (a[i.name] = i.value), a;
  }, {}), n = e.getAttribute("title"), r = e.getAttribute("data-fa-title-id");
  return k.autoA11y && (n ? t["aria-labelledby"] = "".concat(k.replacementClass, "-title-").concat(r || ot()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function Ui() {
  return {
    iconName: null,
    title: null,
    titleId: null,
    prefix: null,
    transform: he,
    symbol: !1,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    extra: {
      classes: [],
      styles: {},
      attributes: {}
    }
  };
}
function ar(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    styleParser: !0
  }, n = zi(e), r = n.iconName, a = n.prefix, i = n.rest, o = Yi(e), s = ln("parseNodeAttributes", {}, e), c = t.styleParser ? Fi(e) : [];
  return g({
    iconName: r,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: a,
    transform: he,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: c,
      attributes: o
    }
  }, s);
}
var Gi = de.styles;
function ua(e) {
  var t = k.autoReplaceSvg === "nest" ? ar(e, {
    styleParser: !1
  }) : ar(e);
  return ~t.extra.classes.indexOf(qr) ? Oe("generateLayersText", e, t) : Oe("generateSvgReplacementMutation", e, t);
}
var $e = /* @__PURE__ */ new Set();
Cn.map(function(e) {
  $e.add("fa-".concat(e));
});
Object.keys(nt[V]).map($e.add.bind($e));
Object.keys(nt[J]).map($e.add.bind($e));
$e = ct($e);
function ir(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  if (!Ae)
    return Promise.resolve();
  var n = X.documentElement.classList, r = function(m) {
    return n.add("".concat(qn, "-").concat(m));
  }, a = function(m) {
    return n.remove("".concat(qn, "-").concat(m));
  }, i = k.autoFetchSvg ? $e : Cn.map(function(l) {
    return "fa-".concat(l);
  }).concat(Object.keys(Gi));
  i.includes("fa") || i.push("fa");
  var o = [".".concat(qr, ":not([").concat(je, "])")].concat(i.map(function(l) {
    return ".".concat(l, ":not([").concat(je, "])");
  })).join(", ");
  if (o.length === 0)
    return Promise.resolve();
  var s = [];
  try {
    s = qe(e.querySelectorAll(o));
  } catch {
  }
  if (s.length > 0)
    r("pending"), a("complete");
  else
    return Promise.resolve();
  var c = Rn.begin("onTree"), u = s.reduce(function(l, m) {
    try {
      var p = ua(m);
      p && l.push(p);
    } catch (y) {
      Br || y.name === "MissingIcon" && console.error(y);
    }
    return l;
  }, []);
  return new Promise(function(l, m) {
    Promise.all(u).then(function(p) {
      la(p, function() {
        r("active"), r("complete"), a("pending"), typeof t == "function" && t(), c(), l();
      });
    }).catch(function(p) {
      c(), m(p);
    });
  });
}
function Hi(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
  ua(e).then(function(n) {
    n && la([n], t);
  });
}
function Bi(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (t || {}).icon ? t : fn(t || {}), a = n.mask;
    return a && (a = (a || {}).icon ? a : fn(a || {})), e(r, g(g({}, n), {}, {
      mask: a
    }));
  };
}
var qi = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.transform, a = r === void 0 ? he : r, i = n.symbol, o = i === void 0 ? !1 : i, s = n.mask, c = s === void 0 ? null : s, u = n.maskId, l = u === void 0 ? null : u, m = n.title, p = m === void 0 ? null : m, y = n.titleId, x = y === void 0 ? null : y, _ = n.classes, O = _ === void 0 ? [] : _, I = n.attributes, A = I === void 0 ? {} : I, h = n.styles, S = h === void 0 ? {} : h;
  if (t) {
    var f = t.prefix, $ = t.iconName, q = t.icon;
    return Wt(g({
      type: "icon"
    }, t), function() {
      return Fe("beforeDOMElementCreation", {
        iconDefinition: t,
        params: n
      }), k.autoA11y && (p ? A["aria-labelledby"] = "".concat(k.replacementClass, "-title-").concat(x || ot()) : (A["aria-hidden"] = "true", A.focusable = "false")), Ln({
        icons: {
          main: un(q),
          mask: c ? un(c.icon) : {
            found: !1,
            width: null,
            height: null,
            icon: {}
          }
        },
        prefix: f,
        iconName: $,
        transform: g(g({}, he), a),
        symbol: o,
        title: p,
        maskId: l,
        titleId: x,
        extra: {
          attributes: A,
          styles: S,
          classes: O
        }
      });
    });
  }
}, Vi = {
  mixout: function() {
    return {
      icon: Bi(qi)
    };
  },
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.treeCallback = ir, n.nodeCallback = Hi, n;
      }
    };
  },
  provides: function(t) {
    t.i2svg = function(n) {
      var r = n.node, a = r === void 0 ? X : r, i = n.callback, o = i === void 0 ? function() {
      } : i;
      return ir(a, o);
    }, t.generateSvgReplacementMutation = function(n, r) {
      var a = r.iconName, i = r.title, o = r.titleId, s = r.prefix, c = r.transform, u = r.symbol, l = r.mask, m = r.maskId, p = r.extra;
      return new Promise(function(y, x) {
        Promise.all([mn(a, s), l.iconName ? mn(l.iconName, l.prefix) : Promise.resolve({
          found: !1,
          width: 512,
          height: 512,
          icon: {}
        })]).then(function(_) {
          var O = En(_, 2), I = O[0], A = O[1];
          y([n, Ln({
            icons: {
              main: I,
              mask: A
            },
            prefix: s,
            iconName: a,
            transform: c,
            symbol: u,
            maskId: m,
            title: i,
            titleId: o,
            extra: p,
            watchable: !0
          })]);
        }).catch(x);
      });
    }, t.generateAbstractIcon = function(n) {
      var r = n.children, a = n.attributes, i = n.main, o = n.transform, s = n.styles, c = $t(s);
      c.length > 0 && (a.style = c);
      var u;
      return Tn(o) && (u = Oe("generateAbstractTransformGrouping", {
        main: i,
        transform: o,
        containerWidth: i.width,
        iconWidth: i.width
      })), r.push(u || i.icon), {
        children: r,
        attributes: a
      };
    };
  }
}, Xi = {
  mixout: function() {
    return {
      layer: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.classes, i = a === void 0 ? [] : a;
        return Wt({
          type: "layer"
        }, function() {
          Fe("beforeDOMElementCreation", {
            assembler: n,
            params: r
          });
          var o = [];
          return n(function(s) {
            Array.isArray(s) ? s.map(function(c) {
              o = o.concat(c.abstract);
            }) : o = o.concat(s.abstract);
          }), [{
            tag: "span",
            attributes: {
              class: ["".concat(k.cssPrefix, "-layers")].concat(ct(i)).join(" ")
            },
            children: o
          }];
        });
      }
    };
  }
}, Zi = {
  mixout: function() {
    return {
      counter: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.title, i = a === void 0 ? null : a, o = r.classes, s = o === void 0 ? [] : o, c = r.attributes, u = c === void 0 ? {} : c, l = r.styles, m = l === void 0 ? {} : l;
        return Wt({
          type: "counter",
          content: n
        }, function() {
          return Fe("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Ci({
            content: n.toString(),
            title: i,
            extra: {
              attributes: u,
              styles: m,
              classes: ["".concat(k.cssPrefix, "-layers-counter")].concat(ct(s))
            }
          });
        });
      }
    };
  }
}, Ki = {
  mixout: function() {
    return {
      text: function(n) {
        var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = r.transform, i = a === void 0 ? he : a, o = r.title, s = o === void 0 ? null : o, c = r.classes, u = c === void 0 ? [] : c, l = r.attributes, m = l === void 0 ? {} : l, p = r.styles, y = p === void 0 ? {} : p;
        return Wt({
          type: "text",
          content: n
        }, function() {
          return Fe("beforeDOMElementCreation", {
            content: n,
            params: r
          }), Qn({
            content: n,
            transform: g(g({}, he), i),
            title: s,
            extra: {
              attributes: m,
              styles: y,
              classes: ["".concat(k.cssPrefix, "-layers-text")].concat(ct(u))
            }
          });
        });
      }
    };
  },
  provides: function(t) {
    t.generateLayersText = function(n, r) {
      var a = r.title, i = r.transform, o = r.extra, s = null, c = null;
      if (Ur) {
        var u = parseInt(getComputedStyle(n).fontSize, 10), l = n.getBoundingClientRect();
        s = l.width / u, c = l.height / u;
      }
      return k.autoA11y && !a && (o.attributes["aria-hidden"] = "true"), Promise.resolve([n, Qn({
        content: n.innerHTML,
        width: s,
        height: c,
        transform: i,
        title: a,
        extra: o,
        watchable: !0
      })]);
    };
  }
}, Ji = new RegExp('"', "ug"), or = [1105920, 1112319];
function Qi(e) {
  var t = e.replace(Ji, ""), n = mi(t, 0), r = n >= or[0] && n <= or[1], a = t.length === 2 ? t[0] === t[1] : !1;
  return {
    value: sn(a ? t[0] : t),
    isSecondary: r || a
  };
}
function sr(e, t) {
  var n = "".concat(za).concat(t.replace(":", "-"));
  return new Promise(function(r, a) {
    if (e.getAttribute(n) !== null)
      return r();
    var i = qe(e.children), o = i.filter(function(q) {
      return q.getAttribute(on) === t;
    })[0], s = Pe.getComputedStyle(e, t), c = s.getPropertyValue("font-family").match(Ba), u = s.getPropertyValue("font-weight"), l = s.getPropertyValue("content");
    if (o && !c)
      return e.removeChild(o), r();
    if (c && l !== "none" && l !== "") {
      var m = s.getPropertyValue("content"), p = ~["Sharp"].indexOf(c[2]) ? J : V, y = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(c[2]) ? rt[p][c[2].toLowerCase()] : qa[p][u], x = Qi(m), _ = x.value, O = x.isSecondary, I = c[0].startsWith("FontAwesome"), A = Mn(y, _), h = A;
      if (I) {
        var S = gi(_);
        S.iconName && S.prefix && (A = S.iconName, y = S.prefix);
      }
      if (A && !O && (!o || o.getAttribute(An) !== y || o.getAttribute(In) !== h)) {
        e.setAttribute(n, h), o && e.removeChild(o);
        var f = Ui(), $ = f.extra;
        $.attributes[on] = t, mn(A, y).then(function(q) {
          var re = Ln(g(g({}, f), {}, {
            icons: {
              main: q,
              mask: $n()
            },
            prefix: y,
            iconName: h,
            extra: $,
            watchable: !0
          })), Q = X.createElementNS("http://www.w3.org/2000/svg", "svg");
          t === "::before" ? e.insertBefore(Q, e.firstChild) : e.appendChild(Q), Q.outerHTML = re.map(function(ae) {
            return ft(ae);
          }).join(`
`), e.removeAttribute(n), r();
        }).catch(a);
      } else
        r();
    } else
      r();
  });
}
function eo(e) {
  return Promise.all([sr(e, "::before"), sr(e, "::after")]);
}
function to(e) {
  return e.parentNode !== document.head && !~Ua.indexOf(e.tagName.toUpperCase()) && !e.getAttribute(on) && (!e.parentNode || e.parentNode.tagName !== "svg");
}
function cr(e) {
  if (Ae)
    return new Promise(function(t, n) {
      var r = qe(e.querySelectorAll("*")).filter(to).map(eo), a = Rn.begin("searchPseudoElements");
      fa(), Promise.all(r).then(function() {
        a(), pn(), t();
      }).catch(function() {
        a(), pn(), n();
      });
    });
}
var no = {
  hooks: function() {
    return {
      mutationObserverCallbacks: function(n) {
        return n.pseudoElementsCallback = cr, n;
      }
    };
  },
  provides: function(t) {
    t.pseudoElements2svg = function(n) {
      var r = n.node, a = r === void 0 ? X : r;
      k.searchPseudoElements && cr(a);
    };
  }
}, lr = !1, ro = {
  mixout: function() {
    return {
      dom: {
        unwatch: function() {
          fa(), lr = !0;
        }
      }
    };
  },
  hooks: function() {
    return {
      bootstrap: function() {
        rr(ln("mutationObserverCallbacks", {}));
      },
      noAuto: function() {
        ji();
      },
      watch: function(n) {
        var r = n.observeMutationsRoot;
        lr ? pn() : rr(ln("mutationObserverCallbacks", {
          observeMutationsRoot: r
        }));
      }
    };
  }
}, fr = function(t) {
  var n = {
    size: 16,
    x: 0,
    y: 0,
    flipX: !1,
    flipY: !1,
    rotate: 0
  };
  return t.toLowerCase().split(" ").reduce(function(r, a) {
    var i = a.toLowerCase().split("-"), o = i[0], s = i.slice(1).join("-");
    if (o && s === "h")
      return r.flipX = !0, r;
    if (o && s === "v")
      return r.flipY = !0, r;
    if (s = parseFloat(s), isNaN(s))
      return r;
    switch (o) {
      case "grow":
        r.size = r.size + s;
        break;
      case "shrink":
        r.size = r.size - s;
        break;
      case "left":
        r.x = r.x - s;
        break;
      case "right":
        r.x = r.x + s;
        break;
      case "up":
        r.y = r.y - s;
        break;
      case "down":
        r.y = r.y + s;
        break;
      case "rotate":
        r.rotate = r.rotate + s;
        break;
    }
    return r;
  }, n);
}, ao = {
  mixout: function() {
    return {
      parse: {
        transform: function(n) {
          return fr(n);
        }
      }
    };
  },
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-transform");
        return a && (n.transform = fr(a)), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractTransformGrouping = function(n) {
      var r = n.main, a = n.transform, i = n.containerWidth, o = n.iconWidth, s = {
        transform: "translate(".concat(i / 2, " 256)")
      }, c = "translate(".concat(a.x * 32, ", ").concat(a.y * 32, ") "), u = "scale(".concat(a.size / 16 * (a.flipX ? -1 : 1), ", ").concat(a.size / 16 * (a.flipY ? -1 : 1), ") "), l = "rotate(".concat(a.rotate, " 0 0)"), m = {
        transform: "".concat(c, " ").concat(u, " ").concat(l)
      }, p = {
        transform: "translate(".concat(o / 2 * -1, " -256)")
      }, y = {
        outer: s,
        inner: m,
        path: p
      };
      return {
        tag: "g",
        attributes: g({}, y.outer),
        children: [{
          tag: "g",
          attributes: g({}, y.inner),
          children: [{
            tag: r.icon.tag,
            children: r.icon.children,
            attributes: g(g({}, r.icon.attributes), y.path)
          }]
        }]
      };
    };
  }
}, zt = {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%"
};
function ur(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
function io(e) {
  return e.tag === "g" ? e.children : [e];
}
var oo = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-mask"), i = a ? Rt(a.split(" ").map(function(o) {
          return o.trim();
        })) : $n();
        return i.prefix || (i.prefix = Me()), n.mask = i, n.maskId = r.getAttribute("data-fa-mask-id"), n;
      }
    };
  },
  provides: function(t) {
    t.generateAbstractMask = function(n) {
      var r = n.children, a = n.attributes, i = n.main, o = n.mask, s = n.maskId, c = n.transform, u = i.width, l = i.icon, m = o.width, p = o.icon, y = ai({
        transform: c,
        containerWidth: m,
        iconWidth: u
      }), x = {
        tag: "rect",
        attributes: g(g({}, zt), {}, {
          fill: "white"
        })
      }, _ = l.children ? {
        children: l.children.map(ur)
      } : {}, O = {
        tag: "g",
        attributes: g({}, y.inner),
        children: [ur(g({
          tag: l.tag,
          attributes: g(g({}, l.attributes), y.path)
        }, _))]
      }, I = {
        tag: "g",
        attributes: g({}, y.outer),
        children: [O]
      }, A = "mask-".concat(s || ot()), h = "clip-".concat(s || ot()), S = {
        tag: "mask",
        attributes: g(g({}, zt), {}, {
          id: A,
          maskUnits: "userSpaceOnUse",
          maskContentUnits: "userSpaceOnUse"
        }),
        children: [x, I]
      }, f = {
        tag: "defs",
        children: [{
          tag: "clipPath",
          attributes: {
            id: h
          },
          children: io(p)
        }, S]
      };
      return r.push(f, {
        tag: "rect",
        attributes: g({
          fill: "currentColor",
          "clip-path": "url(#".concat(h, ")"),
          mask: "url(#".concat(A, ")")
        }, zt)
      }), {
        children: r,
        attributes: a
      };
    };
  }
}, so = {
  provides: function(t) {
    var n = !1;
    Pe.matchMedia && (n = Pe.matchMedia("(prefers-reduced-motion: reduce)").matches), t.missingIconAbstract = function() {
      var r = [], a = {
        fill: "currentColor"
      }, i = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
      };
      r.push({
        tag: "path",
        attributes: g(g({}, a), {}, {
          d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
      });
      var o = g(g({}, i), {}, {
        attributeName: "opacity"
      }), s = {
        tag: "circle",
        attributes: g(g({}, a), {}, {
          cx: "256",
          cy: "364",
          r: "28"
        }),
        children: []
      };
      return n || s.children.push({
        tag: "animate",
        attributes: g(g({}, i), {}, {
          attributeName: "r",
          values: "28;14;28;28;14;28;"
        })
      }, {
        tag: "animate",
        attributes: g(g({}, o), {}, {
          values: "1;0;1;1;0;1;"
        })
      }), r.push(s), r.push({
        tag: "path",
        attributes: g(g({}, a), {}, {
          opacity: "1",
          d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: n ? [] : [{
          tag: "animate",
          attributes: g(g({}, o), {}, {
            values: "1;0;0;0;0;1;"
          })
        }]
      }), n || r.push({
        tag: "path",
        attributes: g(g({}, a), {}, {
          opacity: "0",
          d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [{
          tag: "animate",
          attributes: g(g({}, o), {}, {
            values: "0;0;1;1;0;0;"
          })
        }]
      }), {
        tag: "g",
        attributes: {
          class: "missing"
        },
        children: r
      };
    };
  }
}, co = {
  hooks: function() {
    return {
      parseNodeAttributes: function(n, r) {
        var a = r.getAttribute("data-fa-symbol"), i = a === null ? !1 : a === "" ? !0 : a;
        return n.symbol = i, n;
      }
    };
  }
}, lo = [si, Vi, Xi, Zi, Ki, no, ro, ao, oo, so, co];
xi(lo, {
  mixoutsTo: fe
});
fe.noAuto;
fe.config;
fe.library;
fe.dom;
var vn = fe.parse;
fe.findIconDefinition;
fe.toHtml;
var fo = fe.icon;
fe.layer;
fe.text;
fe.counter;
function uo(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var bn = { exports: {} }, xt = { exports: {} }, Y = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mr;
function mo() {
  if (mr)
    return Y;
  mr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
  function h(f) {
    if (typeof f == "object" && f !== null) {
      var $ = f.$$typeof;
      switch ($) {
        case t:
          switch (f = f.type, f) {
            case c:
            case u:
            case r:
            case i:
            case a:
            case m:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case l:
                case x:
                case y:
                case o:
                  return f;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function S(f) {
    return h(f) === u;
  }
  return Y.AsyncMode = c, Y.ConcurrentMode = u, Y.ContextConsumer = s, Y.ContextProvider = o, Y.Element = t, Y.ForwardRef = l, Y.Fragment = r, Y.Lazy = x, Y.Memo = y, Y.Portal = n, Y.Profiler = i, Y.StrictMode = a, Y.Suspense = m, Y.isAsyncMode = function(f) {
    return S(f) || h(f) === c;
  }, Y.isConcurrentMode = S, Y.isContextConsumer = function(f) {
    return h(f) === s;
  }, Y.isContextProvider = function(f) {
    return h(f) === o;
  }, Y.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === t;
  }, Y.isForwardRef = function(f) {
    return h(f) === l;
  }, Y.isFragment = function(f) {
    return h(f) === r;
  }, Y.isLazy = function(f) {
    return h(f) === x;
  }, Y.isMemo = function(f) {
    return h(f) === y;
  }, Y.isPortal = function(f) {
    return h(f) === n;
  }, Y.isProfiler = function(f) {
    return h(f) === i;
  }, Y.isStrictMode = function(f) {
    return h(f) === a;
  }, Y.isSuspense = function(f) {
    return h(f) === m;
  }, Y.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === r || f === u || f === i || f === a || f === m || f === p || typeof f == "object" && f !== null && (f.$$typeof === x || f.$$typeof === y || f.$$typeof === o || f.$$typeof === s || f.$$typeof === l || f.$$typeof === O || f.$$typeof === I || f.$$typeof === A || f.$$typeof === _);
  }, Y.typeOf = h, Y;
}
var U = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dr;
function po() {
  return dr || (dr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
    function h(d) {
      return typeof d == "string" || typeof d == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      d === r || d === u || d === i || d === a || d === m || d === p || typeof d == "object" && d !== null && (d.$$typeof === x || d.$$typeof === y || d.$$typeof === o || d.$$typeof === s || d.$$typeof === l || d.$$typeof === O || d.$$typeof === I || d.$$typeof === A || d.$$typeof === _);
    }
    function S(d) {
      if (typeof d == "object" && d !== null) {
        var ce = d.$$typeof;
        switch (ce) {
          case t:
            var we = d.type;
            switch (we) {
              case c:
              case u:
              case r:
              case i:
              case a:
              case m:
                return we;
              default:
                var Xe = we && we.$$typeof;
                switch (Xe) {
                  case s:
                  case l:
                  case x:
                  case y:
                  case o:
                    return Xe;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var f = c, $ = u, q = s, re = o, Q = t, ae = l, E = r, C = x, F = y, te = n, oe = i, K = a, _e = m, Le = !1;
    function Ve(d) {
      return Le || (Le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), v(d) || S(d) === c;
    }
    function v(d) {
      return S(d) === u;
    }
    function w(d) {
      return S(d) === s;
    }
    function L(d) {
      return S(d) === o;
    }
    function P(d) {
      return typeof d == "object" && d !== null && d.$$typeof === t;
    }
    function N(d) {
      return S(d) === l;
    }
    function W(d) {
      return S(d) === r;
    }
    function T(d) {
      return S(d) === x;
    }
    function M(d) {
      return S(d) === y;
    }
    function D(d) {
      return S(d) === n;
    }
    function z(d) {
      return S(d) === i;
    }
    function j(d) {
      return S(d) === a;
    }
    function ie(d) {
      return S(d) === m;
    }
    U.AsyncMode = f, U.ConcurrentMode = $, U.ContextConsumer = q, U.ContextProvider = re, U.Element = Q, U.ForwardRef = ae, U.Fragment = E, U.Lazy = C, U.Memo = F, U.Portal = te, U.Profiler = oe, U.StrictMode = K, U.Suspense = _e, U.isAsyncMode = Ve, U.isConcurrentMode = v, U.isContextConsumer = w, U.isContextProvider = L, U.isElement = P, U.isForwardRef = N, U.isFragment = W, U.isLazy = T, U.isMemo = M, U.isPortal = D, U.isProfiler = z, U.isStrictMode = j, U.isSuspense = ie, U.isValidElementType = h, U.typeOf = S;
  }()), U;
}
var pr;
function ma() {
  return pr || (pr = 1, process.env.NODE_ENV === "production" ? xt.exports = mo() : xt.exports = po()), xt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Yt, vr;
function vo() {
  if (vr)
    return Yt;
  vr = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var c = Object.getOwnPropertyNames(o).map(function(l) {
        return o[l];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(l) {
        u[l] = l;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Yt = a() ? Object.assign : function(i, o) {
    for (var s, c = r(i), u, l = 1; l < arguments.length; l++) {
      s = Object(arguments[l]);
      for (var m in s)
        t.call(s, m) && (c[m] = s[m]);
      if (e) {
        u = e(s);
        for (var p = 0; p < u.length; p++)
          n.call(s, u[p]) && (c[u[p]] = s[u[p]]);
      }
    }
    return c;
  }, Yt;
}
var Ut, br;
function Dn() {
  if (br)
    return Ut;
  br = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ut = e, Ut;
}
var Gt, yr;
function da() {
  return yr || (yr = 1, Gt = Function.call.bind(Object.prototype.hasOwnProperty)), Gt;
}
var Ht, hr;
function bo() {
  if (hr)
    return Ht;
  hr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Dn(), n = {}, r = da();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, s, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var l in i)
        if (r(i, l)) {
          var m;
          try {
            if (typeof i[l] != "function") {
              var p = Error(
                (c || "React class") + ": " + s + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            m = i[l](o, l, c, s, null, t);
          } catch (x) {
            m = x;
          }
          if (m && !(m instanceof Error) && e(
            (c || "React class") + ": type specification of " + s + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof m + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), m instanceof Error && !(m.message in n)) {
            n[m.message] = !0;
            var y = u ? u() : "";
            e(
              "Failed " + s + " type: " + m.message + (y ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ht = a, Ht;
}
var Bt, gr;
function yo() {
  if (gr)
    return Bt;
  gr = 1;
  var e = ma(), t = vo(), n = Dn(), r = da(), a = bo(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(s) {
    var c = "Warning: " + s;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Bt = function(s, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, l = "@@iterator";
    function m(v) {
      var w = v && (u && v[u] || v[l]);
      if (typeof w == "function")
        return w;
    }
    var p = "<<anonymous>>", y = {
      array: I("array"),
      bigint: I("bigint"),
      bool: I("boolean"),
      func: I("function"),
      number: I("number"),
      object: I("object"),
      string: I("string"),
      symbol: I("symbol"),
      any: A(),
      arrayOf: h,
      element: S(),
      elementType: f(),
      instanceOf: $,
      node: ae(),
      objectOf: re,
      oneOf: q,
      oneOfType: Q,
      shape: C,
      exact: F
    };
    function x(v, w) {
      return v === w ? v !== 0 || 1 / v === 1 / w : v !== v && w !== w;
    }
    function _(v, w) {
      this.message = v, this.data = w && typeof w == "object" ? w : {}, this.stack = "";
    }
    _.prototype = Error.prototype;
    function O(v) {
      if (process.env.NODE_ENV !== "production")
        var w = {}, L = 0;
      function P(W, T, M, D, z, j, ie) {
        if (D = D || p, j = j || M, ie !== n) {
          if (c) {
            var d = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw d.name = "Invariant Violation", d;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ce = D + ":" + M;
            !w[ce] && // Avoid spamming the console because they are often not actionable except for lib authors
            L < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + j + "` prop on `" + D + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), w[ce] = !0, L++);
          }
        }
        return T[M] == null ? W ? T[M] === null ? new _("The " + z + " `" + j + "` is marked as required " + ("in `" + D + "`, but its value is `null`.")) : new _("The " + z + " `" + j + "` is marked as required in " + ("`" + D + "`, but its value is `undefined`.")) : null : v(T, M, D, z, j);
      }
      var N = P.bind(null, !1);
      return N.isRequired = P.bind(null, !0), N;
    }
    function I(v) {
      function w(L, P, N, W, T, M) {
        var D = L[P], z = K(D);
        if (z !== v) {
          var j = _e(D);
          return new _(
            "Invalid " + W + " `" + T + "` of type " + ("`" + j + "` supplied to `" + N + "`, expected ") + ("`" + v + "`."),
            { expectedType: v }
          );
        }
        return null;
      }
      return O(w);
    }
    function A() {
      return O(o);
    }
    function h(v) {
      function w(L, P, N, W, T) {
        if (typeof v != "function")
          return new _("Property `" + T + "` of component `" + N + "` has invalid PropType notation inside arrayOf.");
        var M = L[P];
        if (!Array.isArray(M)) {
          var D = K(M);
          return new _("Invalid " + W + " `" + T + "` of type " + ("`" + D + "` supplied to `" + N + "`, expected an array."));
        }
        for (var z = 0; z < M.length; z++) {
          var j = v(M, z, N, W, T + "[" + z + "]", n);
          if (j instanceof Error)
            return j;
        }
        return null;
      }
      return O(w);
    }
    function S() {
      function v(w, L, P, N, W) {
        var T = w[L];
        if (!s(T)) {
          var M = K(T);
          return new _("Invalid " + N + " `" + W + "` of type " + ("`" + M + "` supplied to `" + P + "`, expected a single ReactElement."));
        }
        return null;
      }
      return O(v);
    }
    function f() {
      function v(w, L, P, N, W) {
        var T = w[L];
        if (!e.isValidElementType(T)) {
          var M = K(T);
          return new _("Invalid " + N + " `" + W + "` of type " + ("`" + M + "` supplied to `" + P + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return O(v);
    }
    function $(v) {
      function w(L, P, N, W, T) {
        if (!(L[P] instanceof v)) {
          var M = v.name || p, D = Ve(L[P]);
          return new _("Invalid " + W + " `" + T + "` of type " + ("`" + D + "` supplied to `" + N + "`, expected ") + ("instance of `" + M + "`."));
        }
        return null;
      }
      return O(w);
    }
    function q(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function w(L, P, N, W, T) {
        for (var M = L[P], D = 0; D < v.length; D++)
          if (x(M, v[D]))
            return null;
        var z = JSON.stringify(v, function(ie, d) {
          var ce = _e(d);
          return ce === "symbol" ? String(d) : d;
        });
        return new _("Invalid " + W + " `" + T + "` of value `" + String(M) + "` " + ("supplied to `" + N + "`, expected one of " + z + "."));
      }
      return O(w);
    }
    function re(v) {
      function w(L, P, N, W, T) {
        if (typeof v != "function")
          return new _("Property `" + T + "` of component `" + N + "` has invalid PropType notation inside objectOf.");
        var M = L[P], D = K(M);
        if (D !== "object")
          return new _("Invalid " + W + " `" + T + "` of type " + ("`" + D + "` supplied to `" + N + "`, expected an object."));
        for (var z in M)
          if (r(M, z)) {
            var j = v(M, z, N, W, T + "." + z, n);
            if (j instanceof Error)
              return j;
          }
        return null;
      }
      return O(w);
    }
    function Q(v) {
      if (!Array.isArray(v))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var w = 0; w < v.length; w++) {
        var L = v[w];
        if (typeof L != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Le(L) + " at index " + w + "."
          ), o;
      }
      function P(N, W, T, M, D) {
        for (var z = [], j = 0; j < v.length; j++) {
          var ie = v[j], d = ie(N, W, T, M, D, n);
          if (d == null)
            return null;
          d.data && r(d.data, "expectedType") && z.push(d.data.expectedType);
        }
        var ce = z.length > 0 ? ", expected one of type [" + z.join(", ") + "]" : "";
        return new _("Invalid " + M + " `" + D + "` supplied to " + ("`" + T + "`" + ce + "."));
      }
      return O(P);
    }
    function ae() {
      function v(w, L, P, N, W) {
        return te(w[L]) ? null : new _("Invalid " + N + " `" + W + "` supplied to " + ("`" + P + "`, expected a ReactNode."));
      }
      return O(v);
    }
    function E(v, w, L, P, N) {
      return new _(
        (v || "React class") + ": " + w + " type `" + L + "." + P + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + N + "`."
      );
    }
    function C(v) {
      function w(L, P, N, W, T) {
        var M = L[P], D = K(M);
        if (D !== "object")
          return new _("Invalid " + W + " `" + T + "` of type `" + D + "` " + ("supplied to `" + N + "`, expected `object`."));
        for (var z in v) {
          var j = v[z];
          if (typeof j != "function")
            return E(N, W, T, z, _e(j));
          var ie = j(M, z, N, W, T + "." + z, n);
          if (ie)
            return ie;
        }
        return null;
      }
      return O(w);
    }
    function F(v) {
      function w(L, P, N, W, T) {
        var M = L[P], D = K(M);
        if (D !== "object")
          return new _("Invalid " + W + " `" + T + "` of type `" + D + "` " + ("supplied to `" + N + "`, expected `object`."));
        var z = t({}, L[P], v);
        for (var j in z) {
          var ie = v[j];
          if (r(v, j) && typeof ie != "function")
            return E(N, W, T, j, _e(ie));
          if (!ie)
            return new _(
              "Invalid " + W + " `" + T + "` key `" + j + "` supplied to `" + N + "`.\nBad object: " + JSON.stringify(L[P], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(v), null, "  ")
            );
          var d = ie(M, j, N, W, T + "." + j, n);
          if (d)
            return d;
        }
        return null;
      }
      return O(w);
    }
    function te(v) {
      switch (typeof v) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !v;
        case "object":
          if (Array.isArray(v))
            return v.every(te);
          if (v === null || s(v))
            return !0;
          var w = m(v);
          if (w) {
            var L = w.call(v), P;
            if (w !== v.entries) {
              for (; !(P = L.next()).done; )
                if (!te(P.value))
                  return !1;
            } else
              for (; !(P = L.next()).done; ) {
                var N = P.value;
                if (N && !te(N[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function oe(v, w) {
      return v === "symbol" ? !0 : w ? w["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && w instanceof Symbol : !1;
    }
    function K(v) {
      var w = typeof v;
      return Array.isArray(v) ? "array" : v instanceof RegExp ? "object" : oe(w, v) ? "symbol" : w;
    }
    function _e(v) {
      if (typeof v > "u" || v === null)
        return "" + v;
      var w = K(v);
      if (w === "object") {
        if (v instanceof Date)
          return "date";
        if (v instanceof RegExp)
          return "regexp";
      }
      return w;
    }
    function Le(v) {
      var w = _e(v);
      switch (w) {
        case "array":
        case "object":
          return "an " + w;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + w;
        default:
          return w;
      }
    }
    function Ve(v) {
      return !v.constructor || !v.constructor.name ? p : v.constructor.name;
    }
    return y.checkPropTypes = a, y.resetWarningCache = a.resetWarningCache, y.PropTypes = y, y;
  }, Bt;
}
var qt, _r;
function ho() {
  if (_r)
    return qt;
  _r = 1;
  var e = Dn();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, qt = function() {
    function r(o, s, c, u, l, m) {
      if (m !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, qt;
}
if (process.env.NODE_ENV !== "production") {
  var go = ma(), _o = !0;
  bn.exports = yo()(go.isElement, _o);
} else
  bn.exports = ho()();
var wo = bn.exports;
const R = /* @__PURE__ */ uo(wo);
function wr(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Te(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wr(Object(n), !0).forEach(function(r) {
      Ge(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wr(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Tt(e) {
  "@babel/helpers - typeof";
  return Tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Tt(e);
}
function Ge(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function xo(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function So(e, t) {
  if (e == null)
    return {};
  var n = xo(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function yn(e) {
  return ko(e) || Eo(e) || Oo(e) || Ao();
}
function ko(e) {
  if (Array.isArray(e))
    return hn(e);
}
function Eo(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Oo(e, t) {
  if (e) {
    if (typeof e == "string")
      return hn(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return hn(e, t);
  }
}
function hn(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Ao() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Io(e) {
  var t, n = e.beat, r = e.fade, a = e.beatFade, i = e.bounce, o = e.shake, s = e.flash, c = e.spin, u = e.spinPulse, l = e.spinReverse, m = e.pulse, p = e.fixedWidth, y = e.inverse, x = e.border, _ = e.listItem, O = e.flip, I = e.size, A = e.rotation, h = e.pull, S = (t = {
    "fa-beat": n,
    "fa-fade": r,
    "fa-beat-fade": a,
    "fa-bounce": i,
    "fa-shake": o,
    "fa-flash": s,
    "fa-spin": c,
    "fa-spin-reverse": l,
    "fa-spin-pulse": u,
    "fa-pulse": m,
    "fa-fw": p,
    "fa-inverse": y,
    "fa-border": x,
    "fa-li": _,
    "fa-flip": O === !0,
    "fa-flip-horizontal": O === "horizontal" || O === "both",
    "fa-flip-vertical": O === "vertical" || O === "both"
  }, Ge(t, "fa-".concat(I), typeof I < "u" && I !== null), Ge(t, "fa-rotate-".concat(A), typeof A < "u" && A !== null && A !== 0), Ge(t, "fa-pull-".concat(h), typeof h < "u" && h !== null), Ge(t, "fa-swap-opacity", e.swapOpacity), t);
  return Object.keys(S).map(function(f) {
    return S[f] ? f : null;
  }).filter(function(f) {
    return f;
  });
}
function Co(e) {
  return e = e - 0, e === e;
}
function pa(e) {
  return Co(e) ? e : (e = e.replace(/[\-_\s]+(.)?/g, function(t, n) {
    return n ? n.toUpperCase() : "";
  }), e.substr(0, 1).toLowerCase() + e.substr(1));
}
var No = ["style"];
function To(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
function Po(e) {
  return e.split(";").map(function(t) {
    return t.trim();
  }).filter(function(t) {
    return t;
  }).reduce(function(t, n) {
    var r = n.indexOf(":"), a = pa(n.slice(0, r)), i = n.slice(r + 1).trim();
    return a.startsWith("webkit") ? t[To(a)] = i : t[a] = i, t;
  }, {});
}
function va(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  if (typeof t == "string")
    return t;
  var r = (t.children || []).map(function(c) {
    return va(e, c);
  }), a = Object.keys(t.attributes || {}).reduce(function(c, u) {
    var l = t.attributes[u];
    switch (u) {
      case "class":
        c.attrs.className = l, delete t.attributes.class;
        break;
      case "style":
        c.attrs.style = Po(l);
        break;
      default:
        u.indexOf("aria-") === 0 || u.indexOf("data-") === 0 ? c.attrs[u.toLowerCase()] = l : c.attrs[pa(u)] = l;
    }
    return c;
  }, {
    attrs: {}
  }), i = n.style, o = i === void 0 ? {} : i, s = So(n, No);
  return a.attrs.style = Te(Te({}, a.attrs.style), o), e.apply(void 0, [t.tag, Te(Te({}, a.attrs), s)].concat(yn(r)));
}
var ba = !1;
try {
  ba = process.env.NODE_ENV === "production";
} catch {
}
function Mo() {
  if (!ba && console && typeof console.error == "function") {
    var e;
    (e = console).error.apply(e, arguments);
  }
}
function xr(e) {
  if (e && Tt(e) === "object" && e.prefix && e.iconName && e.icon)
    return e;
  if (vn.icon)
    return vn.icon(e);
  if (e === null)
    return null;
  if (e && Tt(e) === "object" && e.prefix && e.iconName)
    return e;
  if (Array.isArray(e) && e.length === 2)
    return {
      prefix: e[0],
      iconName: e[1]
    };
  if (typeof e == "string")
    return {
      prefix: "fas",
      iconName: e
    };
}
function Vt(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Ge({}, e, t) : {};
}
var se = /* @__PURE__ */ st.forwardRef(function(e, t) {
  var n = e.icon, r = e.mask, a = e.symbol, i = e.className, o = e.title, s = e.titleId, c = e.maskId, u = xr(n), l = Vt("classes", [].concat(yn(Io(e)), yn(i.split(" ")))), m = Vt("transform", typeof e.transform == "string" ? vn.transform(e.transform) : e.transform), p = Vt("mask", xr(r)), y = fo(u, Te(Te(Te(Te({}, l), m), p), {}, {
    symbol: a,
    title: o,
    titleId: s,
    maskId: c
  }));
  if (!y)
    return Mo("Could not find icon", u), null;
  var x = y.abstract, _ = {
    ref: t
  };
  return Object.keys(e).forEach(function(O) {
    se.defaultProps.hasOwnProperty(O) || (_[O] = e[O]);
  }), $o(x[0], _);
});
se.displayName = "FontAwesomeIcon";
se.propTypes = {
  beat: R.bool,
  border: R.bool,
  beatFade: R.bool,
  bounce: R.bool,
  className: R.string,
  fade: R.bool,
  flash: R.bool,
  mask: R.oneOfType([R.object, R.array, R.string]),
  maskId: R.string,
  fixedWidth: R.bool,
  inverse: R.bool,
  flip: R.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: R.oneOfType([R.object, R.array, R.string]),
  listItem: R.bool,
  pull: R.oneOf(["right", "left"]),
  pulse: R.bool,
  rotation: R.oneOf([0, 90, 180, 270]),
  shake: R.bool,
  size: R.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: R.bool,
  spinPulse: R.bool,
  spinReverse: R.bool,
  symbol: R.oneOfType([R.bool, R.string]),
  title: R.string,
  titleId: R.string,
  transform: R.oneOfType([R.string, R.object]),
  swapOpacity: R.bool
};
se.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var $o = va.bind(null, st.createElement);
function ya(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var a = e.length;
      for (t = 0; t < a; t++)
        e[t] && (n = ya(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function Z() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++)
    (e = arguments[n]) && (t = ya(e)) && (r && (r += " "), r += t);
  return r;
}
var gn = /* @__PURE__ */ ((e) => (e.DEFAULT = "DEFAULT", e.COLUMN = "COLUMN", e))(gn || {}), Lo = /* @__PURE__ */ ((e) => (e.Primary = "primary", e.PrimaryOutline = "primary_outline", e.Info = "info", e.Blank = "blank", e))(Lo || {});
const Ro = "hbbnNa_action_disabled", Wo = "hbbnNa_button__full", Do = "hbbnNa_button__lg", jo = "hbbnNa_button__m", Fo = "hbbnNa_button__s", zo = "hbbnNa_buttonColumn", Yo = "hbbnNa_buttonColumn__icon", Uo = "hbbnNa_buttonColumn__label", Go = "hbbnNa_buttonDefault", Ho = "hbbnNa_buttonIcon", Bo = "hbbnNa_theme__blank", qo = "hbbnNa_theme__disabled", Vo = "hbbnNa_theme__info", Xo = "hbbnNa_theme__primary", Zo = "hbbnNa_theme__primary_outline", xe = {
  action_disabled: Ro,
  button__full: Wo,
  button__lg: Do,
  button__m: jo,
  button__s: Fo,
  buttonColumn: zo,
  buttonColumn__icon: Yo,
  buttonColumn__label: Uo,
  buttonDefault: Go,
  buttonIcon: Ho,
  theme__blank: Bo,
  theme__disabled: qo,
  theme__info: Vo,
  theme__primary: Xo,
  theme__primary_outline: Zo
}, Ko = ({
  label: e,
  variant: t,
  size: n,
  icon: r,
  disabled: a,
  buttonTheme: i,
  children: o,
  isQuestionAction: s = !1,
  className: c,
  ...u
}) => {
  const l = me(
    () => n ? xe[`button__${n}`] : null,
    [n]
  ), m = me(() => a ? s ? xe.action_disabled : xe.theme__disabled : i ? xe[`theme__${i}`] : null, [i, a, s]), p = me(() => {
    switch (t) {
      case gn.COLUMN:
        return /* @__PURE__ */ B(tt, { children: [
          r && /* @__PURE__ */ b("div", { className: xe.buttonColumn__icon, children: /* @__PURE__ */ b(se, { icon: r }) }),
          /* @__PURE__ */ b("div", { className: xe.buttonColumn__label, children: e })
        ] });
      default:
        return /* @__PURE__ */ B(tt, { children: [
          r && /* @__PURE__ */ b(
            se,
            {
              icon: r,
              className: Z({ [xe.buttonIcon]: !!e })
            }
          ),
          e
        ] });
    }
  }, [t, r, e]);
  return /* @__PURE__ */ B(
    "button",
    {
      className: Z(
        xe.buttonDefault,
        l,
        m,
        {
          [xe.buttonColumn]: t === gn.COLUMN
        },
        c
      ),
      "aria-label": e,
      disabled: a,
      ...u,
      children: [
        o,
        p
      ]
    }
  );
};
var Jo = {
  prefix: "far",
  iconName: "file-lines",
  icon: [384, 512, [128441, 128462, 61686, "file-alt", "file-text"], "f15c", "M64 464c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm56 256c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120z"]
}, Qo = {
  prefix: "far",
  iconName: "chevron-up",
  icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
}, es = {
  prefix: "far",
  iconName: "cloud-arrow-up",
  icon: [640, 512, [62338, "cloud-upload", "cloud-upload-alt"], "f0ee", "M354.9 121.7c13.8 16 36.5 21.1 55.9 12.5c8.9-3.9 18.7-6.2 29.2-6.2c39.8 0 72 32.2 72 72c0 4-.3 7.9-.9 11.7c-3.5 21.6 8.1 42.9 28.1 51.7C570.4 276.9 592 308 592 344c0 46.8-36.6 85.2-82.8 87.8c-.6 0-1.3 .1-1.9 .2H504 144c-53 0-96-43-96-96c0-41.7 26.6-77.3 64-90.5c19.2-6.8 32-24.9 32-45.3l0-.2v0 0c0-66.3 53.7-120 120-120c36.3 0 68.8 16.1 90.9 41.7zM512 480v-.2c71.4-4.1 128-63.3 128-135.8c0-55.7-33.5-103.7-81.5-124.7c1-6.3 1.5-12.8 1.5-19.3c0-66.3-53.7-120-120-120c-17.4 0-33.8 3.7-48.7 10.3C360.4 54.6 314.9 32 264 32C171.2 32 96 107.2 96 200l0 .2C40.1 220 0 273.3 0 336c0 79.5 64.5 144 144 144H464h40 8zM223 255c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l39-39V384c0 13.3 10.7 24 24 24s24-10.7 24-24V249.9l39 39c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-80-80c-9.4-9.4-24.6-9.4-33.9 0l-80 80z"]
}, ts = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, ha = {
  prefix: "far",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
}, ns = {
  prefix: "far",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
}, rs = ns, as = {
  prefix: "far",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
}, is = {
  prefix: "far",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
}, _n = { exports: {} }, Xt = {};
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Sr;
function os() {
  if (Sr)
    return Xt;
  Sr = 1;
  var e = st;
  function t(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, a = e.useRef, i = e.useEffect, o = e.useMemo, s = e.useDebugValue;
  return Xt.useSyncExternalStoreWithSelector = function(c, u, l, m, p) {
    var y = a(null);
    if (y.current === null) {
      var x = { hasValue: !1, value: null };
      y.current = x;
    } else
      x = y.current;
    y = o(function() {
      function O(f) {
        if (!I) {
          if (I = !0, A = f, f = m(f), p !== void 0 && x.hasValue) {
            var $ = x.value;
            if (p($, f))
              return h = $;
          }
          return h = f;
        }
        if ($ = h, n(A, f))
          return $;
        var q = m(f);
        return p !== void 0 && p($, q) ? $ : (A = f, h = q);
      }
      var I = !1, A, h, S = l === void 0 ? null : l;
      return [function() {
        return O(u());
      }, S === null ? void 0 : function() {
        return O(S());
      }];
    }, [u, l, m, p]);
    var _ = r(c, y[0], y[1]);
    return i(function() {
      x.hasValue = !0, x.value = _;
    }, [_]), s(_), _;
  }, Xt;
}
var kr = {};
/**
 * @license React
 * use-sync-external-store-with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Er;
function ss() {
  return Er || (Er = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var e = st;
    function t(u, l) {
      return u === l && (u !== 0 || 1 / u === 1 / l) || u !== u && l !== l;
    }
    var n = typeof Object.is == "function" ? Object.is : t, r = e.useSyncExternalStore, a = e.useRef, i = e.useEffect, o = e.useMemo, s = e.useDebugValue;
    function c(u, l, m, p, y) {
      var x = a(null), _;
      x.current === null ? (_ = {
        hasValue: !1,
        value: null
      }, x.current = _) : _ = x.current;
      var O = o(function() {
        var S = !1, f, $, q = function(E) {
          if (!S) {
            S = !0, f = E;
            var C = p(E);
            if (y !== void 0 && _.hasValue) {
              var F = _.value;
              if (y(F, C))
                return $ = F, F;
            }
            return $ = C, C;
          }
          var te = f, oe = $;
          if (n(te, E))
            return oe;
          var K = p(E);
          return y !== void 0 && y(oe, K) ? oe : (f = E, $ = K, K);
        }, re = m === void 0 ? null : m, Q = function() {
          return q(l());
        }, ae = re === null ? void 0 : function() {
          return q(re());
        };
        return [Q, ae];
      }, [l, m, p, y]), I = O[0], A = O[1], h = r(u, I, A);
      return i(function() {
        _.hasValue = !0, _.value = h;
      }, [h]), s(h), h;
    }
    kr.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), kr;
}
process.env.NODE_ENV === "production" ? _n.exports = os() : _n.exports = ss();
var cs = _n.exports, Or = (
  // prettier-ignore
  // @ts-ignore
  "default" in Se ? Se.default : Se
), ls = (e) => {
}, fs = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
fs ? Or.useLayoutEffect : Or.useEffect;
ls(cs.useSyncExternalStoreWithSelector);
var Pt = function() {
  return Pt = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Pt.apply(this, arguments);
};
function ga(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
var wn = { exports: {} }, G = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function us() {
  if (Ar)
    return G;
  Ar = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
  function h(f) {
    if (typeof f == "object" && f !== null) {
      var $ = f.$$typeof;
      switch ($) {
        case t:
          switch (f = f.type, f) {
            case c:
            case u:
            case r:
            case i:
            case a:
            case m:
              return f;
            default:
              switch (f = f && f.$$typeof, f) {
                case s:
                case l:
                case x:
                case y:
                case o:
                  return f;
                default:
                  return $;
              }
          }
        case n:
          return $;
      }
    }
  }
  function S(f) {
    return h(f) === u;
  }
  return G.AsyncMode = c, G.ConcurrentMode = u, G.ContextConsumer = s, G.ContextProvider = o, G.Element = t, G.ForwardRef = l, G.Fragment = r, G.Lazy = x, G.Memo = y, G.Portal = n, G.Profiler = i, G.StrictMode = a, G.Suspense = m, G.isAsyncMode = function(f) {
    return S(f) || h(f) === c;
  }, G.isConcurrentMode = S, G.isContextConsumer = function(f) {
    return h(f) === s;
  }, G.isContextProvider = function(f) {
    return h(f) === o;
  }, G.isElement = function(f) {
    return typeof f == "object" && f !== null && f.$$typeof === t;
  }, G.isForwardRef = function(f) {
    return h(f) === l;
  }, G.isFragment = function(f) {
    return h(f) === r;
  }, G.isLazy = function(f) {
    return h(f) === x;
  }, G.isMemo = function(f) {
    return h(f) === y;
  }, G.isPortal = function(f) {
    return h(f) === n;
  }, G.isProfiler = function(f) {
    return h(f) === i;
  }, G.isStrictMode = function(f) {
    return h(f) === a;
  }, G.isSuspense = function(f) {
    return h(f) === m;
  }, G.isValidElementType = function(f) {
    return typeof f == "string" || typeof f == "function" || f === r || f === u || f === i || f === a || f === m || f === p || typeof f == "object" && f !== null && (f.$$typeof === x || f.$$typeof === y || f.$$typeof === o || f.$$typeof === s || f.$$typeof === l || f.$$typeof === O || f.$$typeof === I || f.$$typeof === A || f.$$typeof === _);
  }, G.typeOf = h, G;
}
var H = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ir;
function ms() {
  return Ir || (Ir = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, l = e ? Symbol.for("react.forward_ref") : 60112, m = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, x = e ? Symbol.for("react.lazy") : 60116, _ = e ? Symbol.for("react.block") : 60121, O = e ? Symbol.for("react.fundamental") : 60117, I = e ? Symbol.for("react.responder") : 60118, A = e ? Symbol.for("react.scope") : 60119;
    function h(d) {
      return typeof d == "string" || typeof d == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      d === r || d === u || d === i || d === a || d === m || d === p || typeof d == "object" && d !== null && (d.$$typeof === x || d.$$typeof === y || d.$$typeof === o || d.$$typeof === s || d.$$typeof === l || d.$$typeof === O || d.$$typeof === I || d.$$typeof === A || d.$$typeof === _);
    }
    function S(d) {
      if (typeof d == "object" && d !== null) {
        var ce = d.$$typeof;
        switch (ce) {
          case t:
            var we = d.type;
            switch (we) {
              case c:
              case u:
              case r:
              case i:
              case a:
              case m:
                return we;
              default:
                var Xe = we && we.$$typeof;
                switch (Xe) {
                  case s:
                  case l:
                  case x:
                  case y:
                  case o:
                    return Xe;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var f = c, $ = u, q = s, re = o, Q = t, ae = l, E = r, C = x, F = y, te = n, oe = i, K = a, _e = m, Le = !1;
    function Ve(d) {
      return Le || (Le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), v(d) || S(d) === c;
    }
    function v(d) {
      return S(d) === u;
    }
    function w(d) {
      return S(d) === s;
    }
    function L(d) {
      return S(d) === o;
    }
    function P(d) {
      return typeof d == "object" && d !== null && d.$$typeof === t;
    }
    function N(d) {
      return S(d) === l;
    }
    function W(d) {
      return S(d) === r;
    }
    function T(d) {
      return S(d) === x;
    }
    function M(d) {
      return S(d) === y;
    }
    function D(d) {
      return S(d) === n;
    }
    function z(d) {
      return S(d) === i;
    }
    function j(d) {
      return S(d) === a;
    }
    function ie(d) {
      return S(d) === m;
    }
    H.AsyncMode = f, H.ConcurrentMode = $, H.ContextConsumer = q, H.ContextProvider = re, H.Element = Q, H.ForwardRef = ae, H.Fragment = E, H.Lazy = C, H.Memo = F, H.Portal = te, H.Profiler = oe, H.StrictMode = K, H.Suspense = _e, H.isAsyncMode = Ve, H.isConcurrentMode = v, H.isContextConsumer = w, H.isContextProvider = L, H.isElement = P, H.isForwardRef = N, H.isFragment = W, H.isLazy = T, H.isMemo = M, H.isPortal = D, H.isProfiler = z, H.isStrictMode = j, H.isSuspense = ie, H.isValidElementType = h, H.typeOf = S;
  }()), H;
}
process.env.NODE_ENV === "production" ? wn.exports = us() : wn.exports = ms();
var ds = wn.exports, _a = ds, ps = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, vs = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, wa = {};
wa[_a.ForwardRef] = ps;
wa[_a.Memo] = vs;
function bs(e, t, n) {
  if (n === void 0 && (n = Error), !e)
    throw new n(t);
}
var ys = function(e) {
  process.env.NODE_ENV !== "production" && console.error(e);
}, hs = function(e) {
  process.env.NODE_ENV !== "production" && console.warn(e);
}, gs = {
  formats: {},
  messages: {},
  timeZone: void 0,
  defaultLocale: "en",
  defaultFormats: {},
  fallbackOnEmptyString: !0,
  onError: ys,
  onWarn: hs
};
function _s(e) {
  bs(e, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
Pt(Pt({}, gs), { textComponent: Se.Fragment });
var jn = typeof window < "u" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = Se.createContext(null)) : Se.createContext(null);
jn.Consumer;
jn.Provider;
var ws = jn;
function xa() {
  var e = Se.useContext(ws);
  return _s(e), e;
}
var xn;
(function(e) {
  e.formatDate = "FormattedDate", e.formatTime = "FormattedTime", e.formatNumber = "FormattedNumber", e.formatList = "FormattedList", e.formatDisplayName = "FormattedDisplayName";
})(xn || (xn = {}));
var Sn;
(function(e) {
  e.formatDate = "FormattedDateParts", e.formatTime = "FormattedTimeParts", e.formatNumber = "FormattedNumberParts", e.formatList = "FormattedListParts";
})(Sn || (Sn = {}));
function Sa(e) {
  var t = function(n) {
    var r = xa(), a = n.value, i = n.children, o = ga(n, ["value", "children"]), s = typeof a == "string" ? new Date(a || 0) : a, c = e === "formatDate" ? r.formatDateToParts(s, o) : r.formatTimeToParts(s, o);
    return i(c);
  };
  return t.displayName = Sn[e], t;
}
function ut(e) {
  var t = function(n) {
    var r = xa(), a = n.value, i = n.children, o = ga(
      n,
      ["value", "children"]
    ), s = r[e](a, o);
    if (typeof i == "function")
      return i(s);
    var c = r.textComponent || Se.Fragment;
    return Se.createElement(c, null, s);
  };
  return t.displayName = xn[e], t;
}
ut("formatDate");
ut("formatTime");
ut("formatNumber");
ut("formatList");
ut("formatDisplayName");
Sa("formatDate");
Sa("formatTime");
let ve, be, ye;
const Fn = (e, t) => t !== void 0 ? t : typeof window < "u" ? window.matchMedia(e).matches : (process.env.NODE_ENV !== "production" && console.warn(
  "`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches."
), !1), xs = () => {
  const [e, t] = pe(Fn("(max-width: 480px)"));
  return ve || (ve = window.matchMedia("(max-width: 480px)")), kn(() => {
    let n = !0;
    const r = () => {
      !n || !ve || t(!!ve.matches);
    };
    return ve == null || ve.addEventListener("change", r, !0), t((ve == null ? void 0 : ve.matches) || !1), () => {
      n = !1, ve == null || ve.removeEventListener("change", r, !0);
    };
  }, []), e;
}, Ss = () => {
  const [e, t] = pe(
    Fn("(min-width: 481px) and (max-width: 800px)")
  );
  return be || (be = window.matchMedia(
    "(min-width: 481px) and (max-width: 800px)"
  )), kn(() => {
    let n = !0;
    const r = () => {
      !n || !be || t(!!be.matches);
    };
    return be == null || be.addEventListener("change", r, !0), t((be == null ? void 0 : be.matches) || !1), () => {
      n = !1, be == null || be.removeEventListener("change", r, !0);
    };
  }, []), e;
}, ks = () => {
  const [e, t] = pe(
    Fn("(min-width: 800px) and (max-width: 1024px)")
  );
  return ye || (ye = window.matchMedia(
    "(min-width: 800px) and (max-width: 1024px)"
  )), kn(() => {
    let n = !0;
    const r = () => {
      !n || !ye || t(!!ye.matches);
    };
    return ye == null || ye.addEventListener("change", r, !0), t((ye == null ? void 0 : ye.matches) || !1), () => {
      n = !1, ye == null || ye.removeEventListener("change", r, !0);
    };
  }, []), e;
}, Es = () => {
  const e = xs(), t = Ss(), n = ks(), r = me(
    () => !e && !t && !n,
    [e, t, n]
  );
  return { isScreenXS: e, isScreenS: t, isScreenM: n, isScreenLG: r };
};
var At = /* @__PURE__ */ ((e) => (e.Medium = "medium", e.Large = "large", e.Full = "full", e))(At || {});
const Os = "NQZ-Zq_activeSection", As = "NQZ-Zq_contentAction", Is = "NQZ-Zq_contentSection", Cs = "NQZ-Zq_contentTitle", Ze = {
  activeSection: Os,
  contentAction: As,
  contentSection: Is,
  contentTitle: Cs
}, Vl = ge(
  ({ children: e, title: t, action: n, size: r, isActive: a, ...i }, o) => {
    const { isScreenXS: s, isScreenS: c, isScreenM: u } = Es(), l = me(() => {
      if (u && !r)
        return "90%";
      if (c)
        return "96%";
      if (s)
        return "100%";
      switch (r) {
        case At.Medium:
          return "640px";
        case At.Large:
          return "900px";
        case At.Full:
          return "100%";
        default:
          return "900px";
      }
    }, [r, u, c, s]);
    return /* @__PURE__ */ B(
      "div",
      {
        className: Z(Ze.contentSection, {
          [Ze.activeSection]: a
        }),
        ref: o,
        ...i,
        style: { ...i.style, width: l },
        children: [
          t && /* @__PURE__ */ b("h2", { className: Ze.contentTitle, children: t }),
          /* @__PURE__ */ b("div", { className: Ze.contentBody, children: e }),
          n && /* @__PURE__ */ B("button", { className: Ze.contentAction, onClick: n.callback, children: [
            n.label,
            " ",
            /* @__PURE__ */ b(se, { icon: as })
          ] })
        ]
      }
    );
  }
), Ns = "cNB8cW_En", Ts = "cNB8cW_flag", Ps = "cNB8cW_Nl", Cr = {
  En: Ns,
  flag: Ts,
  Nl: Ps
}, Nr = ({ culture: e }) => /* @__PURE__ */ b(
  "div",
  {
    className: Z(Cr.flag, e && Cr[e])
  }
);
var Je = /* @__PURE__ */ ((e) => (e.Warning = "Warning", e.Info = "Info", e.Error = "Error", e.Success = "Success", e.Disabled = "Disabled", e))(Je || {});
const Ms = "Z7O-8W_hintComponent", $s = "Z7O-8W_infoIcon", Ls = "Z7O-8W_removeElement", Rs = "Z7O-8W_theme_danger", Ws = "Z7O-8W_theme_info", Ds = "Z7O-8W_theme_success", js = "Z7O-8W_theme_warning", Fs = "Z7O-8W_withBorder", zs = "Z7O-8W_withShadow", Ce = {
  hintComponent: Ms,
  infoIcon: $s,
  removeElement: Ls,
  theme_danger: Rs,
  theme_info: Ws,
  theme_success: Ds,
  theme_warning: js,
  withBorder: Fs,
  withShadow: zs
}, Xl = ({
  content: e,
  hintIcon: t = ts,
  hintTheme: n = "info",
  showBorder: r = !1,
  showShadow: a = !1,
  ...i
}) => {
  const o = me(() => {
    switch (n) {
      case Je.Warning:
        return Ce.theme_warning;
      case Je.Error:
        return Ce.theme_danger;
      case Je.Success:
        return Ce.theme_success;
      case Je.Info:
      default:
        return Ce.theme_info;
    }
  }, [n]);
  return /* @__PURE__ */ b("div", { className: Z(o), ...i, children: /* @__PURE__ */ B(
    "div",
    {
      className: Z(Ce.hintComponent, {
        [Ce.withShadow]: a,
        [Ce.withBorder]: r
      }),
      children: [
        /* @__PURE__ */ b(se, { icon: t, className: Ce.infoIcon }),
        /* @__PURE__ */ b("div", { dangerouslySetInnerHTML: { __html: e } })
      ]
    }
  ) });
}, Ys = "ASUZ4q_active", Us = "ASUZ4q_bottom", Gs = "ASUZ4q_languageButton", Hs = "ASUZ4q_languageList", Bs = "ASUZ4q_languageSelect", qs = "ASUZ4q_toggleButton", Vs = "ASUZ4q_top", Re = {
  active: Ys,
  bottom: Us,
  languageButton: Gs,
  languageList: Hs,
  languageSelect: Bs,
  toggleButton: qs,
  top: Vs
};
var ka = /* @__PURE__ */ ((e) => (e.En = "En", e.Nl = "Nl", e))(ka || {});
const Zl = ({
  dropdownAnchor: e = "bottom",
  currentCulture: t,
  setCulture: n
}) => {
  const [r, a] = pe(!1), i = Mt(null), o = le(() => {
    a((l) => !l);
  }, []), s = le(
    (l) => {
      n(l), a(!1);
    },
    [n]
  ), c = le((l) => {
    switch (l) {
      case "En":
        return "English";
      case "Nl":
        return "Nederlands";
    }
  }, []), u = le((l) => {
    var m;
    (m = i.current) != null && m.contains(l.target) || a(!1);
  }, []);
  return ze(() => (window.addEventListener("click", u), () => {
    window.removeEventListener("click", u);
  }), [u]), /* @__PURE__ */ B("div", { className: Re.languageSelect, ref: i, children: [
    /* @__PURE__ */ B(
      "button",
      {
        className: Re.toggleButton,
        "aria-expanded": r,
        onClick: o,
        "data-testid": "toggle",
        "data-cy": "LanguageSelectToggle",
        children: [
          /* @__PURE__ */ b(Nr, { culture: t }),
          c(t),
          /* @__PURE__ */ b(se, { icon: r ? Qo : ha })
        ]
      }
    ),
    r && /* @__PURE__ */ b(
      "ul",
      {
        className: Z(Re.languageList, Re[e]),
        "data-testid": "language-dropdown",
        children: Object.values(ka).map((l, m) => {
          const p = l === t;
          return /* @__PURE__ */ b("li", { className: Re.languageItem, children: /* @__PURE__ */ B(
            "button",
            {
              "aria-selected": p,
              className: Z(Re.languageButton, {
                [Re.active]: p
              }),
              onClick: () => s(l),
              "data-cy": `LanguageSelect${l}`,
              "data-testid": `culture-${l}`,
              children: [
                /* @__PURE__ */ b(Nr, { culture: l }),
                c(l)
              ]
            }
          ) }, l || m);
        })
      }
    )
  ] });
}, Xs = "gMHvrG_Blank", Zs = "gMHvrG_Danger", Ks = "gMHvrG_Info", Js = "gMHvrG_pillContainer", Qs = "gMHvrG_Primary", ec = "gMHvrG_radiusLG", tc = "gMHvrG_radiusMD", nc = "gMHvrG_radiusSM", rc = "gMHvrG_Secondary", ac = "gMHvrG_Success", ic = "gMHvrG_Warning", Zt = {
  Blank: Xs,
  Danger: Zs,
  Info: Ks,
  pillContainer: Js,
  Primary: Qs,
  radiusLG: ec,
  radiusMD: tc,
  radiusSM: nc,
  Secondary: rc,
  Success: ac,
  Warning: ic
}, Kl = ({
  pillTheme: e,
  children: t,
  radius: n = "LG",
  label: r,
  ...a
}) => /* @__PURE__ */ B(
  "div",
  {
    className: Z(
      Zt.pillContainer,
      e && Zt[e],
      Zt[`radius${n}`]
    ),
    ...a,
    children: [
      r,
      t
    ]
  }
);
var oc = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
};
const sc = "utV6eq_container", cc = {
  container: sc
}, Jl = ({
  name: e,
  value: t,
  label: n,
  onChange: r,
  disabled: a,
  ...i
}) => {
  const [o, s] = pe(t), c = le(
    (u) => {
      s(u.currentTarget.checked), r == null || r(u);
    },
    [r]
  );
  return ze(() => {
    s(t);
  }, [t]), /* @__PURE__ */ b("div", { className: cc.container, children: /* @__PURE__ */ B("label", { children: [
    /* @__PURE__ */ b(
      "input",
      {
        ...i,
        name: e,
        type: "checkbox",
        checked: o,
        onChange: c,
        disabled: a
      }
    ),
    /* @__PURE__ */ b("span", { children: !!o && /* @__PURE__ */ b(se, { icon: oc }) }),
    !!n && /* @__PURE__ */ b("span", { children: n })
  ] }) });
}, lc = "j5qA6G_container", fc = "j5qA6G_input", uc = "j5qA6G_prepend", Kt = {
  container: lc,
  input: fc,
  prepend: uc
}, Ql = ({
  name: e,
  value: t,
  placeholder: n,
  ...r
}) => {
  const [a, i] = pe((t == null ? void 0 : t.toString()) || ""), o = le(
    (s) => {
      i(s.target.value);
    },
    []
  );
  return /* @__PURE__ */ B("div", { className: Kt.container, children: [
    /* @__PURE__ */ b("div", { className: Kt.prepend, children: "€" }),
    /* @__PURE__ */ b(
      "input",
      {
        ...r,
        type: "text",
        name: e,
        value: a || "",
        onChange: o,
        className: Kt.input,
        placeholder: n
      }
    )
  ] });
}, mc = "bF12iG_container", dc = "bF12iG_input", Tr = {
  container: mc,
  input: dc
}, ef = ge(
  ({ type: e = "date", ...t }, n) => /* @__PURE__ */ b("div", { className: Tr.container, children: /* @__PURE__ */ b("input", { ...t, ref: n, type: e, className: Tr.input }) })
);
var ue = /* @__PURE__ */ ((e) => (e.Pending = "Pending", e.FileSelected = "FileSelected", e.Success = "Success", e.Loading = "Loading", e.Error = "Error", e))(ue || {});
const pc = "Uz0AyW_breathe", vc = "Uz0AyW_browserInput", bc = "Uz0AyW_fileInputContent", yc = "Uz0AyW_fileInputIcon", hc = "Uz0AyW_fileInputSelectedWrapper", gc = "Uz0AyW_fileInputSubtitle", _c = "Uz0AyW_fileInputTitle", wc = "Uz0AyW_fileInputWrapper", xc = "Uz0AyW_loading_background", Sc = "Uz0AyW_removeIcon", kc = "Uz0AyW_selectedFileDescription", Ec = "Uz0AyW_selectedFileDetails", Oc = "Uz0AyW_selectedFileTitle", Ac = "Uz0AyW_selectedIconWrapper", Ic = "Uz0AyW_theme_loading", Cc = "Uz0AyW_theme_pending", Nc = "Uz0AyW_theme_selected", Tc = "Uz0AyW_theme_success", ne = {
  breathe: pc,
  browserInput: vc,
  fileInputContent: bc,
  fileInputIcon: yc,
  fileInputSelectedWrapper: hc,
  fileInputSubtitle: gc,
  fileInputTitle: _c,
  fileInputWrapper: wc,
  loading_background: xc,
  removeIcon: Sc,
  selectedFileDescription: kc,
  selectedFileDetails: Ec,
  selectedFileTitle: Oc,
  selectedIconWrapper: Ac,
  theme_loading: Ic,
  theme_pending: Cc,
  theme_selected: Nc,
  theme_success: Tc
}, Pc = ({ title: e, subtitle: t }) => /* @__PURE__ */ B("div", { className: ne.fileInputContent, "data-cy": "FileInputPlaceholder", children: [
  /* @__PURE__ */ b(
    se,
    {
      className: ne.fileInputIcon,
      icon: es,
      fontSize: 32
    }
  ),
  /* @__PURE__ */ b("h3", { className: ne.fileInputTitle, children: e }),
  /* @__PURE__ */ b(
    "div",
    {
      dangerouslySetInnerHTML: { __html: t },
      className: ne.fileInputSubtitle
    }
  )
] });
function Mc(e, t = 2) {
  if (!e || e === 0)
    return "0 Bytes";
  const n = 1024, r = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], a = Math.floor(Math.log(e) / Math.log(n));
  return `${parseFloat((e / Math.pow(n, a)).toFixed(t))} ${r[a]}`;
}
const $c = ({
  file: e,
  fileSizeText: t,
  onRemove: n,
  status: r
}) => {
  const a = le(
    (i) => {
      i.preventDefault(), i.stopPropagation(), n == null || n();
    },
    [n]
  );
  return /* @__PURE__ */ B(
    "div",
    {
      className: ne.fileInputSelectedWrapper,
      "data-cy": "FileInputSelected",
      children: [
        r === ue.Loading && /* @__PURE__ */ b("div", { className: ne.loading_background }),
        /* @__PURE__ */ b("div", { className: ne.selectedIconWrapper, children: /* @__PURE__ */ b(se, { icon: Jo }) }),
        /* @__PURE__ */ B("div", { className: ne.selectedFileDetails, children: [
          /* @__PURE__ */ b("div", { className: ne.selectedFileTitle, children: e.name }),
          /* @__PURE__ */ B("div", { className: ne.selectedFileDescription, children: [
            t,
            " ",
            Mc(e.size)
          ] })
        ] }),
        r !== ue.Success && r !== ue.Loading && /* @__PURE__ */ b(
          Ko,
          {
            onClick: (i) => a(i),
            style: { zIndex: 10 },
            "data-testid": "clearFileButton",
            children: /* @__PURE__ */ b(
              se,
              {
                icon: rs,
                className: ne.removeIcon,
                fontSize: 18
              }
            )
          }
        )
      ]
    }
  );
}, tf = ({
  acceptedFiles: e,
  filesizeText: t,
  placeholderTitle: n,
  placeholderSubtitle: r,
  status: a,
  singleFileCallback: i,
  removeFileCallback: o,
  rejectFileCallback: s,
  "data-cy": c,
  ...u
}) => {
  const l = Mt(null), m = () => {
    var A;
    if (!l.current || !l.current.files || ((A = l.current.files) == null ? void 0 : A.length) === 0)
      return;
    const O = l.current.files[0].name.split(".").pop() || "";
    if (!(e && e.map((h) => h.slice(1)).includes(O))) {
      s == null || s();
      return;
    }
    i == null || i(l.current.files[0]);
  }, p = () => {
    l.current && (o == null || o(), l.current.value = "");
  }, y = me(() => {
    var _;
    switch (a) {
      case ue.Pending:
      case ue.Error:
        return ne.theme_pending;
      case (ue.FileSelected || ((_ = l == null ? void 0 : l.current) == null ? void 0 : _.value)):
        return ne.theme_selected;
      case ue.Loading:
        return ne.theme_loading;
      case ue.Success:
        return ne.theme_success;
      default:
        return null;
    }
  }, [a]), x = me(() => {
    switch (a) {
      case ue.Pending:
      case ue.Error:
        return !1;
      default:
        return !0;
    }
  }, [a]);
  return /* @__PURE__ */ B(
    "div",
    {
      className: Z(ne.fileInputWrapper, y),
      "data-cy": c,
      children: [
        /* @__PURE__ */ b(
          "input",
          {
            ...u,
            ref: l,
            type: "file",
            onChange: m,
            className: ne.browserInput,
            disabled: a === ue.Loading,
            accept: e == null ? void 0 : e.join(", "),
            "data-cy": "UploadFileInput",
            "data-testid": "UploadFileInput"
          }
        ),
        !x && /* @__PURE__ */ b(
          Pc,
          {
            title: n,
            subtitle: r
          }
        ),
        l.current && l.current.files && l.current.value && x && /* @__PURE__ */ b(
          $c,
          {
            fileSizeText: t,
            onRemove: p,
            file: l.current.files[0],
            status: a
          }
        )
      ]
    }
  );
}, Lc = "WJdBlq_container", Rc = "WJdBlq_input", Pr = {
  container: Lc,
  input: Rc
}, nf = ge(
  ({ removeLeadingZeroes: e, onInput: t, ...n }, r) => {
    const a = (i) => {
      const { value: o } = i.target, s = Number(o);
      e && (i.target.value = s.toString()), t == null || t(i);
    };
    return /* @__PURE__ */ b("div", { className: Pr.container, children: /* @__PURE__ */ b(
      "input",
      {
        ...n,
        ref: r,
        type: "number",
        onInput: a,
        className: Pr.input
      }
    ) });
  }
), Wc = "OHPPAa_inputValue", Dc = "OHPPAa_labelCenter", jc = "OHPPAa_radioGroupContainer", Jt = {
  inputValue: Wc,
  labelCenter: Dc,
  radioGroupContainer: jc
}, rf = ({
  name: e,
  value: t,
  values: n,
  showLabels: r,
  disabled: a,
  radioInputNativeProps: i,
  onChange: o,
  className: s,
  ...c
}) => /* @__PURE__ */ b(
  "div",
  {
    ...c,
    className: Z(Jt.radioGroupContainer, s),
    children: n.map((u, l) => /* @__PURE__ */ B(
      "label",
      {
        className: Z({
          [Jt.labelCenter]: !r
        }),
        children: [
          /* @__PURE__ */ b(
            "input",
            {
              ...i,
              name: e,
              type: "radio",
              checked: t === u.value,
              value: u.value,
              onChange: o,
              disabled: a
            }
          ),
          /* @__PURE__ */ b("span", {}),
          r && !!u.label && /* @__PURE__ */ b("span", { className: Jt.inputValue, children: u.label })
        ]
      },
      l
    ))
  }
), Fc = "MqDmTq_container", zc = "MqDmTq_input", Mr = {
  container: Fc,
  input: zc
}, af = st.forwardRef(
  ({ extraStyles: e, className: t, ...n }, r) => /* @__PURE__ */ b("div", { className: Mr.container, style: e, children: /* @__PURE__ */ b(
    "input",
    {
      ...n,
      ref: r,
      type: "text",
      className: Z(Mr.input, t)
    }
  ) })
), Yc = "_pvN-G_charCounter", Uc = "_pvN-G_container", Gc = "_pvN-G_full", Hc = "_pvN-G_input", St = {
  charCounter: Yc,
  container: Uc,
  full: Gc,
  input: Hc
}, of = ge(
  ({ maxLength: e, className: t, onInput: n, ...r }, a) => {
    const [i, o] = pe(0), s = (c) => {
      n && n(c), e && c.target.value.length > e && (c.target.value = c.target.value.slice(0, e)), o(c.currentTarget.value.length);
    };
    return /* @__PURE__ */ B("div", { className: St.container, children: [
      /* @__PURE__ */ b(
        "textarea",
        {
          onInput: s,
          ...r,
          ref: a,
          className: Z(St.input, t)
        }
      ),
      e && /* @__PURE__ */ B(
        "div",
        {
          className: Z(St.charCounter, {
            [St.full]: i === e
          }),
          children: [
            i,
            " / ",
            e
          ]
        }
      )
    ] });
  }
), Bc = "KaIJza_inputErrorWrapper", qc = {
  inputErrorWrapper: Bc
}, Vc = "input-error", Ea = ({ errorMessage: e, ...t }) => /* @__PURE__ */ b(tt, { children: e && /* @__PURE__ */ b(
  "div",
  {
    ...t,
    className: qc.inputErrorWrapper,
    "data-testid": Vc,
    children: e
  }
) }), Xc = "_3vDiSa_inputLabel", Zc = {
  inputLabel: Xc
}, Kc = "input-label", Oa = ({ label: e, ...t }) => /* @__PURE__ */ b(tt, { children: e && /* @__PURE__ */ b(
  "label",
  {
    className: Zc.inputLabel,
    ...t,
    "data-testid": Kc,
    children: e
  }
) }), Jc = "_9lDY4a_error", Qc = "_9lDY4a_styledInput", $r = {
  error: Jc,
  styledInput: Qc
}, Aa = ge(
  ({ hasError: e, "data-cy": t, className: n, ...r }, a) => /* @__PURE__ */ b(
    "input",
    {
      "data-cy": t,
      ...r,
      ref: a,
      className: Z(
        $r.styledInput,
        n,
        e && $r.error
      )
    }
  )
), el = "gWQWNG_input", tl = "gWQWNG_inputWrapper", Lr = {
  input: el,
  inputWrapper: tl
}, nl = "radio-input", Ia = ge(
  ({ label: e, value: t, ...n }, r) => /* @__PURE__ */ B("label", { className: Lr.inputWrapper, children: [
    /* @__PURE__ */ b(
      "input",
      {
        "data-testid": nl,
        type: "radio",
        value: t,
        ref: r,
        ...n,
        className: Lr.input
      }
    ),
    e
  ] })
), rl = "RoeXmW_checkmark", al = "RoeXmW_container", Rr = {
  checkmark: rl,
  container: al
}, Ca = ge(
  ({ label: e, ...t }, n) => /* @__PURE__ */ B("label", { className: Rr.container, children: [
    /* @__PURE__ */ b("input", { ref: n, ...t, type: "checkbox" }),
    /* @__PURE__ */ b("span", { children: /* @__PURE__ */ b(se, { className: Rr.checkmark, icon: is }) }),
    !!e && /* @__PURE__ */ b("span", { children: e })
  ] })
), il = "otHOpq_dropdownListOption", ol = "otHOpq_dropdownListWrapper", sl = "otHOpq_emptyState", Qt = {
  dropdownListOption: il,
  dropdownListWrapper: ol,
  emptyState: sl
}, cl = "Qll2fW_container", ll = "Qll2fW_loader", fl = "Qll2fW_rotation", Wr = {
  container: cl,
  loader: ll,
  rotation: fl
}, ul = "loading-spinner-selector", ml = ({ size: e = 30 }) => /* @__PURE__ */ b("div", { className: Wr.container, "data-testid": ul, children: /* @__PURE__ */ b(
  "div",
  {
    className: Wr.loader,
    style: { height: e, width: e }
  }
) }), Dr = {
  emptyState: "emptyState",
  element: "list-item"
}, Na = ({
  connectedParentRef: e,
  optionsList: t,
  isVisible: n,
  children: r,
  closeDropdown: a,
  openDropdown: i,
  onOptionSelect: o,
  onFocus: s,
  onBlur: c,
  position: u,
  maxHeight: l = 250,
  autoFocus: m = !1,
  isLoading: p = !1,
  emptyResultsDisplay: y,
  className: x,
  style: _,
  "data-cy": O
}) => {
  const I = Mt(null), [A, h] = pe(), S = le(
    (E) => {
      var C;
      o(E), a == null || a(), (C = e == null ? void 0 : e.current) == null || C.focus();
    },
    [e, o, a]
  ), f = le(
    (E) => {
      var F, te;
      const C = E.target;
      !((F = e == null ? void 0 : e.current) != null && F.contains(C)) && !((te = I == null ? void 0 : I.current) != null && te.contains(C)) && (c == null || c(t[A ?? 0]), a == null || a());
    },
    [t, A, c, a, e]
  ), $ = me(
    () => y ?? /* @__PURE__ */ b(
      "div",
      {
        className: Qt.emptyState,
        "data-testid": Dr.emptyState,
        children: "Geen resultaten gevonden"
      }
    ),
    [y]
  ), q = le(
    (E) => {
      var C, F, te, oe;
      (C = I.current) != null && C.contains(document.activeElement) || !((F = e == null ? void 0 : e.current) != null && F.contains(document.activeElement)) || (E.code === "ArrowDown" && (h(0), i == null || i(), (te = I == null ? void 0 : I.current) == null || te.focus()), E.code === "ArrowUp" && (h(t.length - 1), i == null || i(), (oe = I == null ? void 0 : I.current) == null || oe.focus()), (E.code === "ArrowLeft" || E.code === "ArrowRight") && (h((K) => K || 0), i == null || i()));
    },
    [t, i, e]
  ), re = me(() => {
    if (!n || !(e != null && e.current))
      return {};
    const E = {
      maxHeight: l
    };
    if (u)
      return E.bottom = u === "top" ? "100%" : "unset", E.top = u === "bottom" ? "100%" : "unset", E;
    const C = e.current, { y: F } = C.getBoundingClientRect(), oe = window.innerHeight - F - C.offsetHeight, K = Math.max(oe, F);
    return oe > l ? E.top = "100%" : K !== F ? E.bottom = "100%" : E.top = "100%", E.maxHeight = Math.min(K - 20, l), E;
  }, [e, l, u, n]), Q = le(
    (E) => {
      var C;
      switch (E.code) {
        case "ArrowUp":
          E.preventDefault(), h(
            (F) => F === void 0 ? void 0 : Math.max(F - 1, 0)
          );
          break;
        case "ArrowDown":
          E.preventDefault(), h(
            (F) => F === void 0 ? 0 : Math.min(F + 1, t.length - 1)
          );
          break;
        case "Enter":
          E.preventDefault(), E.stopPropagation(), S(t[A || 0]);
          break;
        case "Home":
          E.stopPropagation(), h(0);
          break;
        case "End":
          E.stopPropagation(), h(t.length - 1);
          break;
        case "Tab":
          E.preventDefault(), (C = e == null ? void 0 : e.current) == null || C.focus();
          break;
        case "Escape":
          a == null || a();
          break;
      }
    },
    [
      t,
      A,
      S,
      e,
      a
    ]
  );
  ze(() => {
    var E;
    m && ((E = I.current) == null || E.focus());
  }, [m]), ze(() => {
    const E = t[A ?? 0];
    E && (s == null || s(E));
  }, [A, s, t]), ze(() => (document.addEventListener("click", f), document.addEventListener("keydown", q), () => {
    document.removeEventListener("click", f), document.removeEventListener("keydown", q);
  }), [f, q]);
  const ae = le(
    (E) => {
      const C = E == null ? void 0 : E.getAttribute("data-index");
      C && parseInt(C) === A && (E == null || E.focus());
    },
    [A]
  );
  return ze(() => {
    h(void 0);
  }, [t]), /* @__PURE__ */ b(tt, { children: n && /* @__PURE__ */ B(
    "ul",
    {
      role: "listbox",
      className: Z(Qt.dropdownListWrapper, x),
      onKeyDown: Q,
      tabIndex: 1,
      ref: I,
      autoFocus: !0,
      style: { ..._, maxHeight: l, ...re },
      "data-cy": O,
      children: [
        p && /* @__PURE__ */ b(ml, {}),
        !p && t.length === 0 && $,
        !p && (t == null ? void 0 : t.map((E, C) => /* @__PURE__ */ b(
          "li",
          {
            onClick: (F) => {
              F.stopPropagation(), S(E);
            },
            ref: ae,
            "data-index": C,
            role: "option",
            tabIndex: 1,
            className: Qt.dropdownListOption,
            "data-testid": Dr.element,
            children: r(E, { isFocused: C === A })
          },
          C
        )))
      ]
    }
  ) });
}, sf = {
  InputError: Ea,
  InputLabel: Oa,
  StyledInput: Aa,
  RadioInput: Ia,
  CheckboxInput: Ca,
  DropdownList: Na
}, dl = "Y0wolG_borderOverwrite", pl = "Y0wolG_hasError", vl = "Y0wolG_inputDecoratorWrapper", en = {
  borderOverwrite: dl,
  hasError: pl,
  inputDecoratorWrapper: vl
}, mt = ({
  children: e,
  className: t,
  labelProps: n,
  errorProps: r,
  borderOverwrite: a = !0,
  ...i
}) => /* @__PURE__ */ B(
  "div",
  {
    ...i,
    className: Z(en.inputDecoratorWrapper, t, {
      [en.hasError]: !!(r != null && r.errorMessage),
      [en.borderOverwrite]: a
    }),
    children: [
      /* @__PURE__ */ b(Oa, { ...n }),
      e,
      /* @__PURE__ */ b(Ea, { ...r })
    ]
  }
), bl = "HGHnJa_append", yl = "HGHnJa_input", hl = "HGHnJa_inputPrependAppendWrapper", gl = "HGHnJa_prepend", kt = {
  append: bl,
  input: yl,
  inputPrependAppendWrapper: hl,
  prepend: gl
}, Ta = ({
  prepend: e,
  append: t,
  className: n,
  children: r,
  ...a
}) => /* @__PURE__ */ B(
  "div",
  {
    ...a,
    className: Z(kt.inputPrependAppendWrapper, n),
    children: [
      e && /* @__PURE__ */ b("div", { className: kt.prepend, children: e }),
      /* @__PURE__ */ b("div", { className: kt.input, children: r }),
      t && /* @__PURE__ */ b("div", { className: kt.append, children: t })
    ]
  }
), _l = "NBO3_G_formRowWrapper", wl = {
  formRowWrapper: _l
}, xl = ({
  children: e,
  orientation: t,
  className: n,
  style: r,
  ...a
}) => /* @__PURE__ */ b(
  "div",
  {
    ...a,
    className: Z(wl.formRowWrapper, n),
    style: { flexDirection: t, ...r },
    children: e
  }
), cf = {
  InputDecorator: mt,
  InputPrependAppend: Ta,
  FormRow: xl
}, Sl = "xZ4jiG_input", kl = "xZ4jiG_textInputWrapper", El = {
  input: Sl,
  textInputWrapper: kl
}, Ol = ge(
  ({ name: e, "data-cy": t, label: n, errorMessage: r, ...a }, i) => /* @__PURE__ */ b("div", { className: El.textInputWrapper, children: /* @__PURE__ */ b(
    mt,
    {
      labelProps: {
        label: n,
        htmlFor: e
      },
      errorProps: {
        errorMessage: r
      },
      children: /* @__PURE__ */ b(
        Aa,
        {
          ...a,
          "data-cy": t,
          ref: i,
          name: e,
          id: e,
          hasError: !!r
        }
      )
    }
  ) })
), Al = "T4gEzq_column", Il = "T4gEzq_optionsWrapper", Cl = "T4gEzq_radioGroup", Nl = "T4gEzq_row", tn = {
  column: Al,
  optionsWrapper: Il,
  radioGroup: Cl,
  row: Nl
}, Tl = ge(
  ({
    label: e,
    values: t,
    errorMessage: n,
    optionsWrapperStyles: r,
    orientation: a = "row",
    "data-cy": i,
    name: o,
    ...s
  }, c) => /* @__PURE__ */ b(
    "fieldset",
    {
      className: Z(tn.radioGroup),
      "data-cy": i,
      name: o,
      children: /* @__PURE__ */ b(
        mt,
        {
          errorProps: { errorMessage: n },
          labelProps: { label: e },
          borderOverwrite: !1,
          children: /* @__PURE__ */ b(
            "div",
            {
              className: Z(tn.optionsWrapper, tn[a]),
              style: r,
              children: t == null ? void 0 : t.map((u) => /* @__PURE__ */ b(
                Ia,
                {
                  ...s,
                  name: o,
                  ref: c,
                  ...u
                },
                `${u.value}`
              ))
            }
          )
        }
      )
    }
  )
), Pl = "p1dp1W_chevronWrapper", Ml = "p1dp1W_errorBorderDropdown", $l = "p1dp1W_errorBorderInput", Ll = "p1dp1W_filterInput", Rl = "p1dp1W_hiddenInput", Wl = "p1dp1W_inputDecoratorWrapper", Dl = "p1dp1W_isDisabled", jl = "p1dp1W_selectInput", Fl = "p1dp1W_valueDisplay", Ne = {
  chevronWrapper: Pl,
  errorBorderDropdown: Ml,
  errorBorderInput: $l,
  filterInput: Ll,
  hiddenInput: Rl,
  inputDecoratorWrapper: Wl,
  isDisabled: Dl,
  selectInput: jl,
  valueDisplay: Fl
}, zl = ({
  optionsList: e,
  onOptionSelect: t,
  onOptionChange: n,
  selectedOptionRender: r,
  selectedOptionCompare: a,
  children: i,
  emptyResultsDisplay: o,
  isLoading: s,
  label: c,
  errorMessage: u,
  position: l,
  disabled: m,
  allowFilter: p,
  connectRef: y,
  "data-cy": x,
  ..._
}) => {
  const O = Mt(null), [I, A] = pe(!1), [h, S] = pe(""), [f, $] = pe(), q = le(
    (C) => {
      t ? t(C) : f && (f.value = JSON.stringify(C)), n == null || n(C);
    },
    [t, n, f]
  ), re = me(() => !p || h.trim() === "" ? e : e.filter((C) => JSON.stringify(C).toLowerCase().includes(h.toLowerCase().trim())), [p, h, e]), Q = me(() => {
    let C;
    return a ? C = e.find((F) => a(F, f == null ? void 0 : f.value)) : C = e.find((F) => JSON.stringify(F) === (f == null ? void 0 : f.value)), C ? r ? r(C) : JSON.stringify(C) : null;
  }, [f == null ? void 0 : f.value, e, r, a]), ae = () => {
    m || A(!0);
  }, E = () => {
    A(!1);
  };
  return /* @__PURE__ */ b("div", { className: Ne.selectInput, ref: O, "data-cy": x, children: /* @__PURE__ */ b(
    mt,
    {
      tabIndex: m || p ? -1 : 0,
      className: Ne.inputDecoratorWrapper,
      labelProps: { label: c },
      errorProps: { errorMessage: u },
      onClick: ae,
      onFocus: ae,
      borderOverwrite: !1,
      children: /* @__PURE__ */ B(
        Ta,
        {
          append: /* @__PURE__ */ b("div", { className: Ne.chevronWrapper, children: /* @__PURE__ */ b(se, { icon: ha }) }),
          className: Z({
            [Ne.hasError]: !!u,
            [Ne.isDisabled]: m
          }),
          style: { position: "relative" },
          children: [
            /* @__PURE__ */ b(
              "input",
              {
                ..._,
                ref: (C) => {
                  y == null || y(C), $(C);
                },
                className: Ne.hiddenInput,
                disabled: m
              }
            ),
            p && /* @__PURE__ */ b(
              "input",
              {
                disabled: m,
                className: Ne.filterInput,
                value: h,
                onFocus: ae,
                onChange: (C) => S(C.target.value)
              }
            ),
            /* @__PURE__ */ b("div", { className: Ne.valueDisplay, children: Q }),
            /* @__PURE__ */ b(
              Na,
              {
                optionsList: re,
                connectedParentRef: O,
                isVisible: I,
                closeDropdown: E,
                openDropdown: ae,
                onOptionSelect: q,
                emptyResultsDisplay: o,
                isLoading: s,
                position: l,
                children: i
              }
            )
          ]
        }
      )
    }
  ) });
}, Yl = "_1rljbW_checkboxGroup", Ul = {
  checkboxGroup: Yl
}, Gl = ge(
  ({
    checkboxes: e,
    errorMessage: t,
    label: n,
    name: r,
    onChange: a,
    onBlur: i,
    className: o,
    "data-cy": s
  }, c) => /* @__PURE__ */ b(
    "fieldset",
    {
      className: Z(Ul.checkboxGroup, o),
      "data-cy": s,
      children: /* @__PURE__ */ b(mt, { labelProps: { label: n }, errorProps: { errorMessage: t }, children: e.map((u, l) => /* @__PURE__ */ b(
        Ca,
        {
          ...u,
          ref: c,
          name: r,
          onChange: a,
          onBlur: i,
          label: u.label
        },
        l
      )) })
    }
  )
), lf = {
  SelectInput: zl,
  TextInput: Ol,
  RadioGroup: Tl,
  CheckboxGroup: Gl
};
var Hl = /* @__PURE__ */ ((e) => (e.Primary = "Primary", e.Secondary = "Secondary", e.Info = "Info", e.Warning = "Warning", e.Danger = "Danger", e.Success = "Success", e.Blank = "Blank", e))(Hl || {});
function nn(e, t) {
  t && document.documentElement.style.setProperty(`--${e}`, t);
}
const ff = ({
  mainColor: e,
  supportColor: t,
  textColor: n
}) => {
  nn("company-main", e), nn("company-support", t), nn("company-text", n);
};
export {
  sf as Atoms,
  Ko as Button,
  Lo as ButtonThemes,
  Jl as CheckboxInput,
  Vl as ContentSection,
  At as ContentSectionSize,
  Ql as CurrencyInput,
  ef as DateInput,
  tf as FileInput,
  Nr as Flag,
  Xl as Hint,
  Je as HintThemes,
  Ea as InputError,
  Oa as InputLabel,
  Zl as LanguageSelect,
  cf as Molecules,
  nf as NumberInput,
  lf as Organisms,
  Kl as Pill,
  Hl as PillThemes,
  rf as RadioGroup,
  Aa as StyledInput,
  af as TextInput,
  of as TextareaInput,
  ue as UploadStatus,
  ff as setTheme
};
